var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookVisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-a-whole-year",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-a-whole-year:not(.animated) .animable {opacity: 0;}svg#freepik_stories-a-whole-year.animated #freepik--calendar-bottom--inject-21 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-a-whole-year.animated #freepik--calendar-top--inject-21 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-21",
    className: "animable",
    style: {
      transformOrigin: "258.433px 250.609px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el11gm6ghavyt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "248.588px 250.609px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.1,457.57C44.93,412.73,75.64,349.84,54.28,266.67s-19-115,33-173.1,141.8-79.65,205.86-10.93,123.37,62.18,160,113.23S483,307.4,416.78,350.06,304.35,512.87,161.1,457.57Z",
    style: {
      fill: "current",
      transformOrigin: "258.433px 255.818px"
    },
    id: "elrviiz54frlm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3o08j1pi8ru"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.1,457.57C44.93,412.73,75.64,349.84,54.28,266.67s-19-115,33-173.1,141.8-79.65,205.86-10.93,123.37,62.18,160,113.23S483,307.4,416.78,350.06,304.35,512.87,161.1,457.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "258.433px 255.818px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-21",
    className: "animable",
    style: {
      transformOrigin: "254.312px 245.67px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "126.27 239.34 130.77 246.18 138.96 246.34 133.84 252.74 136.22 260.58 128.55 257.69 121.83 262.37 122.21 254.19 115.68 249.24 123.58 247.07 126.27 239.34",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "127.32px 250.855px"
    },
    id: "eliaawqezhbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.54 317.75 404.95 321.92 407.49 325.6 403.03 325.38 400.32 328.93 399.15 324.62 394.93 323.13 398.67 320.69 398.78 316.22 402.26 319.02 406.54 317.75",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "401.21px 322.575px"
    },
    id: "elww94y2mcho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,112.65a6.32,6.32,0,0,0,.17-1.45,6.45,6.45,0,0,0-6.45-6.45,6.61,6.61,0,0,0-1.68.22,6.19,6.19,0,0,0-11.57,2.65,5.64,5.64,0,0,0-.93-.09,5,5,0,0,0-5,4.49,2.82,2.82,0,0,0,.06,5.63h23.64a2.82,2.82,0,0,0,1.78-5Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "338.583px 109.735px"
    },
    id: "el3adnxp5ojum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71,66.52a3.82,3.82,0,0,0,.1-.9,4,4,0,0,0-5.08-3.9,3.87,3.87,0,0,0-7.24,1.66,3.68,3.68,0,0,0-.58-.06,3.16,3.16,0,0,0-3.14,2.81,1.76,1.76,0,0,0,0,3.52H117.6a1.76,1.76,0,0,0,1.11-3.13Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "110.188px 64.6952px"
    },
    id: "elcefqweynjrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.34,203.86a6.36,6.36,0,0,0-6.5,4.55,6.38,6.38,0,0,0-7.9-.85c-3.83,2.35-3.91,8,.82,11.95,3.42,2.83,8.08,4.17,10.43,4.69l.74.15.57-.49c1.81-1.59,5.25-5,6.87-9.13C341.64,209,338.82,204.08,334.34,203.86Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "328.653px 214.099px"
    },
    id: "el3x09s3xzlda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.14,348.78a3.17,3.17,0,0,0-3.25,2.27,3.21,3.21,0,0,0-4-.43c-1.92,1.18-2,4,.41,6a12.94,12.94,0,0,0,5.21,2.34l.37.08.29-.24a13.09,13.09,0,0,0,3.43-4.57C134.79,351.34,133.38,348.88,131.14,348.78Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "128.251px 353.907px"
    },
    id: "elckb76d58sl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.63,276.49c-1.76-.15-3.52-.31-5.27-.48",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "50.995px 276.25px"
    },
    id: "el9j2pheziq7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.28,226.33c-8.55,2.45-22.49,6.72-21.31,18.2.64,6.21,6,10.85,10.17,15,3.85,3.85,9.36,10.06,3.44,14.86-3.1,2.51-8.22,2.41-12,2.64a106,106,0,0,1-14-.19",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "74.43px 251.753px"
    },
    id: "elyr2xiyyjq3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.31,224.35c-1.93.25-3.85.6-5.75,1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "98.435px 224.85px"
    },
    id: "elzks4t7234rl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,56.51c.28,2.27.57,4.53.85,6.8",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "237.295px 59.91px"
    },
    id: "el30m2zji7hmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28,28l3.09,24.59",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "234.825px 40.295px"
    },
    id: "el265ceu8jjs3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.93,33.14Q251.47,48.92,248,64.7",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "251.465px 48.92px"
    },
    id: "elx63zurv5bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,23.7c-.38,1.73-.76,3.45-1.13,5.18",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.435px 26.29px"
    },
    id: "elyjoo55xx8m9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.53,54.82l-5.1,10.11",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "260.98px 59.875px"
    },
    id: "elxk1otor3is",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.45,39.14l-5.88,11.65",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "268.51px 44.965px"
    },
    id: "elgtbyikumoxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.83,177.6a7.52,7.52,0,0,0-1.59.18,7.24,7.24,0,0,1-4.07,11.59,7.24,7.24,0,1,0,5.66-11.77Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "171.614px 184.84px"
    },
    id: "el014id4aciaseo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.14 389.37 283.68 401.91 268.58 409.67 266.14 389.37",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "274.91px 399.52px"
    },
    id: "elr0okxw64unh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,291c3,2.49,8.61,7.73,5.2,11.92-2.42,3-7.45,3.64-11,4.23-6.62,1.1-14.81,1.05-20.49,5.06-3.68,2.59-3.16,6.26-.49,9.51",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "442.674px 306.36px"
    },
    id: "eleqlzc99qu65",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.34,285.25c1.56.89,3.09,1.81,4.59,2.78",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "447.635px 286.64px"
    },
    id: "el59lbfxzc594",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,447.15c.87,1.19,1.73,2.38,2.6,3.56",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "314.93px 448.93px"
    },
    id: "elzgw1lse9v39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.77,436.34l5.13,7.05",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "308.335px 439.865px"
    },
    id: "elsfzhsyap0h9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.69,
    y1: 443.53,
    x2: 294.69,
    y2: 467.64,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "294.69px 455.585px"
    },
    id: "eljoawhsv9ge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.26,459.18c-.84,2.82-1.69,5.64-2.53,8.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "274.995px 463.41px"
    },
    id: "elh2jgc2spmz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8,450.71l-1.38,4.59",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "278.11px 453.005px"
    },
    id: "eln3nrxgm0kb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.07 294.27 156.67 309.19 172.31 296.71 153.07 294.27",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "162.69px 301.73px"
    },
    id: "els0ruruw1u6b",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar-bottom--inject-21",
    className: "animable animator-active",
    style: {
      transformOrigin: "254.74px 269.085px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elv4kkbi32nq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.52,112.06s10.75-35.89,9.44-49.4c0,0,47.52,9.4,64.63,21.55,0,0-16.82,40.58-16.73,55.25C438.86,139.46,389.34,122,381.52,112.06Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "418.555px 101.06px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elirjvzyeinyn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.09,195.88s24.71,19.58,32.29,33.46L406,243.21s39.13-27.5,49.77-48.93c0,0-52.5-21.15-58.38-29.61S366.09,195.88,366.09,195.88Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "410.93px 203.348px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9gyj7ltgc9w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.48,461.24s22.15-36,23-51.57c0,0,48.35,10.59,59.69,17.17,0,0-24.53,40.34-26.64,57.74A49.23,49.23,0,0,0,368.3,472.8C353.12,470.07,336.48,461.24,336.48,461.24Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "377.825px 447.125px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbjksrzt0rfd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.58,380.29s18.85,50.39,32.46,61.38c0,0-43,34.12-73,29.42,0,0-2-35.8-8-53.24Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "215.54px 425.912px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkqyskbb45s8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.21,418.31s20.07-36.26,20.15-61.57c0,0,29.33,5.79,52.55,17.89,0,0-12,36.43-8.62,57C132.29,431.6,88.84,430.89,68.21,418.31Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "104.56px 394.185px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell6i0fpjhjer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.71,167.75s40.82-15.62,71.41-14.89c0,0,.39,33.66-4.82,53.07,0,0-37.63,16.6-60.72,15.63C59.58,221.56,66.18,193,53.71,167.75Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "89.4183px 187.218px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,430.26c-21.93,13.22-42.3,35.58-69.37,34.37a.71.71,0,0,1-.69-.52,143.64,143.64,0,0,0-7.94-29.46A166.09,166.09,0,0,0,169,410.79a.38.38,0,0,1,.25-.57c15.83-4.35,27.56-15.91,41-24.37a70.48,70.48,0,0,1,13.32-6.72.54.54,0,0,1,.67.32c8.3,19,19.21,36.07,34.37,50.12C258.86,429.77,258.8,430.08,258.49,430.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "213.855px 421.891px"
    },
    id: "elml7at74pfib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,430.26c-21.93,13.22-42.3,35.58-69.37,34.37a.71.71,0,0,1-.69-.52c-3-19.2-9.86-36.83-19.44-53.32a.38.38,0,0,1,.25-.57c20.77-5.71,34.49-23.83,54.37-31.09a.54.54,0,0,1,.67.32c8.3,19,19.21,36.07,34.37,50.12C258.86,429.77,258.8,430.08,258.49,430.26Zm-68.92,33.4c26.38.76,46.24-20.9,67.61-33.8-14.65-14.07-25.35-30.94-33.6-49.57-19.42,7.3-33,25-53.35,30.64A158.12,158.12,0,0,1,189.57,463.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.854px 421.891px"
    },
    id: "elb06dzxe6d2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,395.2c-19.09,7.68-33.2,26.24-54.59,29.72q-3.37-7.28-7.43-14.27c20.77-5.65,34.49-23.77,54.34-31Q227.34,387.65,231.51,395.2Z",
    style: {
      fill: "current",
      transformOrigin: "200.5px 402.285px"
    },
    id: "elhs21av3xh5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.21,395.48c-19.45,7.66-33.72,26.72-55.6,30q-3.54-7.71-7.87-15.08c21.22-5.63,35.06-24.2,55.33-31.41Q227.77,387.5,232.21,395.48Zm-55,28.9c20.91-3.7,34.86-21.77,53.59-29.45q-3.92-7.11-7.23-14.64c-19.42,7.3-33,25-53.35,30.64Q174,417.53,177.22,424.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.475px 402.235px"
    },
    id: "el30rytxi6hod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.36,412.58l-1,.63-.84-1.22-1.23.75.48,1.43-.93.55q-1.29-4-2.65-7.9l1.46-.93Q194,409.22,196.36,412.58Zm-3.45-.91c.32-.2.65-.39,1-.6-.78-1.13-1.56-2.27-2.35-3.4h0C192,409,192.45,410.34,192.91,411.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.275px 410.305px"
    },
    id: "el87orvns735s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,404.3q1.46,2.83,2.88,5.68c.27.53.56.58.87.38s.42-.54.15-1.06q-1.44-2.85-2.89-5.69L196,403c1,1.87,1.91,3.75,2.86,5.62a2,2,0,0,1-.53,2.85c-1,.64-1.81.29-2.41-.89-.93-1.86-1.88-3.73-2.84-5.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.16px 407.393px"
    },
    id: "eloa2w65nj21",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.76,404.75l1.35-1,1.2,2.35a2.07,2.07,0,0,1-.5,2.89c-1,.67-1.8.33-2.4-.85l-1.95-3.84a2.05,2.05,0,0,1,.49-2.88c1-.68,1.79-.36,2.4.83l.36.71-.91.66-.41-.79c-.27-.53-.56-.59-.87-.37s-.4.55-.13,1.08q1,2,2,4c.27.53.56.59.87.37s.41-.55.14-1.08l-.69-1.36-.45.31C200.12,405.46,199.94,405.11,199.76,404.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "199.882px 405.199px"
    },
    id: "elpgjid2wpeud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,399.39l2.92,5.72c.27.53.56.58.87.36s.4-.55.13-1.08L202,398.67l.92-.66q1.42,2.82,2.88,5.65a2.09,2.09,0,0,1-.49,2.9c-.95.69-1.79.36-2.4-.83L200,400.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.09px 402.463px"
    },
    id: "elj93i8etwceh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.82,396.51c.94-.68,1.77-.34,2.37.85l.12.23-.92.65-.15-.31c-.27-.53-.55-.6-.86-.38s-.38.55-.11,1.08.67.8,1.65,1a2.84,2.84,0,0,1,2.25,1.56,2.07,2.07,0,0,1-.49,2.89c-1,.69-1.79.37-2.4-.82-.08-.15-.16-.3-.23-.46l.91-.66.27.53c.27.53.57.58.87.36s.41-.55.14-1.08-.68-.8-1.66-1a2.82,2.82,0,0,1-2.24-1.56A2.06,2.06,0,0,1,204.82,396.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.754px 400.301px"
    },
    id: "elld4z7cj1xhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57,395.37c1-.71,2-1.41,3-2.1l.53,1.07-1,.7q1.6,3.18,3.24,6.35l-1,.68q-1.63-3.17-3.24-6.35l-1,.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.455px 397.67px"
    },
    id: "elojfqa7hl3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.66,429.52c-17.51,11.19-34.21,27.83-55.71,29.88a180.25,180.25,0,0,0-10.22-31c17.58-4.24,30.45-18.69,46.07-26.64A174.29,174.29,0,0,0,249.66,429.52Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "216.695px 430.58px"
    },
    id: "elryz04b2aj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.52,429.59c-17.93,11.39-35,28.58-57.05,30.36A176.43,176.43,0,0,0,183,428c18-4.18,31-19,46.93-27A169.67,169.67,0,0,0,250.52,429.59Zm-56.1,29.25c21-2.29,37.3-18.42,54.39-29.4a178.42,178.42,0,0,1-19.18-27c-15.28,7.94-28,22-45.21,26.3A184,184,0,0,1,194.42,458.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "216.76px 430.475px"
    },
    id: "ele1n9iybbk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.44,432c14.6-5.54,26.22-17.46,39.77-24.61a170.77,170.77,0,0,0,16.45,22.15c-15.23,9.64-29.27,23.24-47,28.22A250.65,250.65,0,0,0,193.44,432Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.55px 432.575px"
    },
    id: "elz90ffbdjtci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.52,429.59c-15.66,9.85-30,23.92-48.31,28.81a245.09,245.09,0,0,0-9.45-26.72c14.94-5.55,26.74-17.82,40.61-25A165.46,165.46,0,0,0,250.52,429.59ZM203,457.07c17.24-5.06,31-18.19,45.77-27.63a174.89,174.89,0,0,1-15.76-21.38c-13.23,7.11-24.67,18.68-38.94,24.22A256.27,256.27,0,0,1,203,457.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.64px 432.54px"
    },
    id: "el2ebb9vpd7r3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19,457.58l-1.13.31a247.54,247.54,0,0,0-11.67-31.7l.92-.37A258.76,258.76,0,0,1,203.19,457.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.79px 441.855px"
    },
    id: "el3ukaj3tng0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,453.74l-1.07.51q-6.21-16.29-13.62-31.93l.86-.5Q206.64,437.5,213,453.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "205.655px 438.035px"
    },
    id: "elplgx7hopet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,448.51l-1,.64q-7.61-15.88-15.47-31.58l.83-.57Q214.6,432.69,222.35,448.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.115px 433.075px"
    },
    id: "el5s2a2dylv2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,442.49l-1,.7q-8.88-15.22-17.06-30.8l.82-.59C219.48,422.16,225.19,432.4,231.21,442.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.18px 427.495px"
    },
    id: "elhio99220hym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.85,436.23l-1,.7a322.27,322.27,0,0,1-18.4-29.65c.27-.19.55-.37.83-.55A300.86,300.86,0,0,0,239.85,436.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.15px 421.83px"
    },
    id: "elt44osvzj33e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.49,407.82c-15.71,8.36-29.06,23.11-47.19,26.82l-.36-.94c18-3.79,31.3-18.48,47-26.78C233.12,407.22,233.31,407.52,233.49,407.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.715px 420.78px"
    },
    id: "el7a2q6maiy2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.34,413.66c-16,8.9-29.93,24-48.73,27.23l-.33-.95c18.68-3.3,32.55-18.35,48.46-27.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.81px 426.84px"
    },
    id: "eledugo5w8bjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4,419.34c-16.34,9.56-31.1,25.12-50.71,27.9l-.3-1c19.48-2.85,34.11-18.33,50.38-27.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.895px 432.845px"
    },
    id: "elnrr09s30hv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.71,424.86c-16.89,10.37-32.61,26.47-53.17,28.84l-.27-1c20.41-2.43,36-18.45,52.78-28.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.99px 438.855px"
    },
    id: "elfvg8utqb6s9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.56,69.14a141.24,141.24,0,0,0-9.83,55.74.5.5,0,0,1-.52.49,193.4,193.4,0,0,1-46.16-6.56q-9.36-2.52-18.49-6a.47.47,0,0,1-.25-.66,156,156,0,0,0,8.41-20.55,149.54,149.54,0,0,0,7.12-37.51.48.48,0,0,1,.51-.48,177.56,177.56,0,0,1,58.94,14.85A.52.52,0,0,1,455.56,69.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "417.928px 89.4897px"
    },
    id: "elrbh901cri5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.21,125.37a192.71,192.71,0,0,1-64.65-12.54.47.47,0,0,1-.25-.66,150.29,150.29,0,0,0,15.53-58.06.48.48,0,0,1,.51-.48,177.56,177.56,0,0,1,58.94,14.85.52.52,0,0,1,.27.66,141.24,141.24,0,0,0-9.83,55.74A.5.5,0,0,1,445.21,125.37Zm-63.69-13.31a196.17,196.17,0,0,0,63.15,12.29,147.61,147.61,0,0,1,9.82-55.14,181.79,181.79,0,0,0-57.72-14.5A156.49,156.49,0,0,1,381.52,112.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.925px 89.4997px"
    },
    id: "elgq9mi62kf88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.09,84.21a372,372,0,0,0-55.77-13.15,155.74,155.74,0,0,0,2-16.91,179.83,179.83,0,0,1,58.79,14.79A146.46,146.46,0,0,0,450.09,84.21Z",
    style: {
      fill: "current",
      transformOrigin: "424.715px 69.18px"
    },
    id: "elkb3zbasqfxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.4,84.82a387.44,387.44,0,0,0-56.62-13.33,152,152,0,0,0,2.09-17.9,177.59,177.59,0,0,1,59.87,15.09A143.79,143.79,0,0,0,450.4,84.82Zm-55.55-14.2a356.88,356.88,0,0,1,54.93,13,150.11,150.11,0,0,1,4.71-14.39,181.79,181.79,0,0,0-57.72-14.5A156,156,0,0,1,394.85,70.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.76px 69.205px"
    },
    id: "ele6ylzldng6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,68.31h0l1.86-5.68,1.54.32q-.81,4.11-1.67,8.22l-1-.22c.4-2,.8-3.93,1.18-5.89h0q-.94,2.88-1.9,5.74l-1-.21c.13-2,.25-4,.34-6h0q-.54,2.91-1.12,5.81l-.94-.19Q414,66.13,414.7,62l1.54.31Q416.1,65.31,415.92,68.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.265px 66.585px"
    },
    id: "el9hdzym2oh2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.91,72.13l-1.08-.25c.05-.51.09-1,.14-1.53l-1.32-.3c-.17.48-.33,1-.5,1.45l-1-.22,2.79-8,1.61.37Q422.26,67.91,421.91,72.13ZM420,69l1,.23.36-4.26h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "420.35px 67.705px"
    },
    id: "elfbx00dlh7zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.64,72.78a3.06,3.06,0,0,1,.13-1l.28-1.28c.17-.76,0-1.09-.47-1.21l-.37-.1c-.25,1.11-.49,2.22-.74,3.33l-1.06-.25c.59-2.73,1.19-5.46,1.78-8.18l1.65.4c1.13.29,1.47,1,1.19,2.29l-.15.63c-.19.84-.54,1.32-1.08,1.46v0c.48.4.52,1.05.33,1.9-.1.42-.19.84-.29,1.25a3.15,3.15,0,0,0-.11,1ZM425,65.5c-.18.84-.37,1.67-.55,2.51l.42.1c.4.1.69,0,.84-.7l.18-.8c.13-.58,0-.88-.36-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.767px 68.555px"
    },
    id: "el7i3vn8gckgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.1,71c-.08.36-.17.72-.25,1.07-.31,1.29-1,1.89-2.07,1.62s-1.42-1.15-1.12-2.45.65-2.81,1-4.22,1-1.9,2.09-1.61,1.44,1.19,1.13,2.47c-.07.27-.13.53-.19.79l-1-.28.21-.87c.14-.57,0-.85-.37-.94s-.62.06-.75.64c-.35,1.46-.69,2.92-1,4.38-.13.58,0,.84.37.93s.6-.07.74-.64l.27-1.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "428.773px 69.5418px"
    },
    id: "el92ha8se0t6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.1,74.44,430,74.16q1-4,2-8l1.08.31c-.29,1.14-.57,2.29-.86,3.43l1.22.35c.29-1.14.58-2.28.88-3.42l1.1.33q-1.05,4-2,7.95l-1.08-.3c.28-1.14.56-2.28.85-3.42L431.93,71C431.65,72.15,431.37,73.3,431.1,74.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "432.71px 70.635px"
    },
    id: "el0i27oz36t3hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.26,120a215.17,215.17,0,0,1-52.77-10.45,188.66,188.66,0,0,0,10.14-32.68q23.69,4.48,47.07,10.85A181.91,181.91,0,0,0,440.26,120Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "416.095px 98.435px"
    },
    id: "eljpwt25mibl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.75,120.54a212.44,212.44,0,0,1-53.95-10.66,185.16,185.16,0,0,0,10.5-33.61q24.13,4.5,47.95,11.08A176.54,176.54,0,0,0,440.75,120.54Zm-52.58-11.33a218.15,218.15,0,0,0,51.61,10.24,186.3,186.3,0,0,1,4.37-31.36q-23-6.15-46.19-10.62A193.05,193.05,0,0,1,388.17,109.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.025px 98.405px"
    },
    id: "elq1v7jsbqx5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,84.72q20.28,4.47,40.62,9.13A183.08,183.08,0,0,0,440.26,120a215.68,215.68,0,0,1-45.55-8.19A276.19,276.19,0,0,0,402.77,84.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "419.05px 102.36px"
    },
    id: "elzoxcrqdlq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.75,120.54A213,213,0,0,1,394,112.18a264.1,264.1,0,0,0,8.41-28.08q20.73,4.53,41.48,9.36A179.09,179.09,0,0,0,440.75,120.54Zm-45.38-9.11a217.76,217.76,0,0,0,44.41,8,186.86,186.86,0,0,1,3.08-25.21q-19.94-4.5-39.78-8.89Q399.87,98.52,395.37,111.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.945px 102.32px"
    },
    id: "elgtjozgtynkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.19,112l-1-.28a265.53,265.53,0,0,0,9.59-33.6l.89.18A281.74,281.74,0,0,1,395.19,112Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "399.43px 95.06px"
    },
    id: "el0ywf4i1gyg4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.82,114.27l-1-.24q5-17.06,8.82-34.33l.88.19Q408.77,97.17,403.82,114.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "407.67px 96.985px"
    },
    id: "eld9df0xu8cis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.53,116.23l-1-.21q4.11-17.3,7.95-34.59l.87.2Q416.54,98.91,412.53,116.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "415.94px 98.83px"
    },
    id: "elupqtsujhn3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.33,117.82l-1-.16q3.15-17.31,7-34.4l.87.21Q424.36,100.53,421.33,117.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.265px 100.54px"
    },
    id: "el5l8x3ihd9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.21,119.05l-1-.12q2.12-17.07,5.9-33.74l.88.23A317.4,317.4,0,0,0,430.21,119.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "432.6px 102.12px"
    },
    id: "elp94uywky0we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,94.34Q419.62,89,396,83.78c.09-.34.17-.68.26-1q23.58,5.1,47.21,10.6C443.43,93.69,443.36,94,443.3,94.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.735px 88.56px"
    },
    id: "el3q6amzwhamm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.17,100.9q-24.23-4.41-48-10.38l.3-1q23.72,5.85,47.85,10.39C442.27,100.23,442.22,100.57,442.17,100.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.245px 95.21px"
    },
    id: "elx3ujlzfocq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.28,107.5a371.63,371.63,0,0,1-49.19-10.3l.33-1a399.28,399.28,0,0,0,49,10.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.755px 101.85px"
    },
    id: "el8cgnybt0tu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,114.16a260.29,260.29,0,0,1-50.89-10.33l.37-1a271.78,271.78,0,0,0,50.61,10.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "415.23px 108.495px"
    },
    id: "el5nkydilnfjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,417.43c-8.09,19.17-13.52,39.49-16.22,63.58,0,.35-.27.45-.51.23-18.65-16.5-47-7-63.49-28.9a.76.76,0,0,1-.13-.85,119.17,119.17,0,0,0,11.74-18.44A163.37,163.37,0,0,0,359.59,405a.39.39,0,0,1,.55-.26C371.37,410,385,408,397.41,409.34c7,.74,13.73,2.54,19.38,7.29A.75.75,0,0,1,417,417.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "376.807px 443.029px"
    },
    id: "eli5rx5mzmbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.22,481.24c-18.65-16.5-47-7-63.49-28.9a.76.76,0,0,1-.13-.85c10.09-12.88,17.75-29.13,23-46.5a.39.39,0,0,1,.55-.26c17.59,8.21,41-1.24,56.65,11.9a.75.75,0,0,1,.16.8c-8.09,19.17-13.52,39.49-16.22,63.58C400.69,481.36,400.46,481.46,400.22,481.24Zm-62.58-29.06c16.38,20.63,43.87,11.89,62.28,27.44A229.12,229.12,0,0,1,416,417.31c-15.5-12.47-38.38-3.62-55.72-11.48C355,422.94,347.5,439.05,337.64,452.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.769px 443.024px"
    },
    id: "eltwb8rvkkjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.38,433.67c-15.87-11.8-38.63-4.21-55.41-14.07q2.8-7,5-14.41c17.56,8.23,40.95-1.15,56.58,11.93Q413.18,425.19,410.38,433.67Z",
    style: {
      fill: "current",
      transformOrigin: "385.76px 419.43px"
    },
    id: "elweka50iyrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.58,434.47c-16-12.28-39.25-4.31-56.17-14.69q3-7.39,5.31-15.24c17.77,8.62,41.68-1.31,57.44,12.4Q413.53,425.46,410.58,434.47Zm-55-15.07c16.62,9.36,38.92,2.15,54.63,13.48q2.65-8,5.83-15.57c-15.5-12.47-38.38-3.62-55.72-11.48Q358.15,412.78,355.54,419.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.785px 419.505px"
    },
    id: "el9db1xt0gwyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.18,420.49l.38,0c.35,0,.69-.1.9-.68q1.05-2.89,2.08-5.78l1.13.05q-1,2.85-2.06,5.72c-.55,1.52-1.46,1.86-2.3,1.79a4.29,4.29,0,0,1-.53-.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.225px 417.814px"
    },
    id: "elxyh16v3wc2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52,414.19q-1.06,3-2.14,5.91c-.19.55,0,.76.31.79s.65-.16.85-.71l2.15-5.94,1.06.05q-1,2.94-2.12,5.88a2.34,2.34,0,0,1-2.37,1.82c-1.1-.07-1.41-.81-1-2l2.1-5.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.918px 418.086px"
    },
    id: "elr39mnzntmli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.52,414.33l1.13.05q-1.22,3.33-2.41,6.65l1.83.15c-.14.37-.27.74-.4,1.11l-2.95-.23C385.65,419.48,386.59,416.9,387.52,414.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.685px 418.31px"
    },
    id: "elqu99x1ouk9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49,419.78c.17-1.78.33-3.56.49-5.32l1.17.08c-.15,1.2-.3,2.41-.46,3.62h0l2.14-3.5,1.06.1q-1.67,2.55-3.31,5.11l-.93,2.59-1.11-.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.215px 418.46px"
    },
    id: "elvsps6pia2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.67,471.94c-16.46-10-38.21-5.77-53.4-19a185.58,185.58,0,0,0,13.89-27c14.82,6.86,33.4,2.89,47.79,10.53A257.87,257.87,0,0,0,396.67,471.94Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "374.11px 448.94px"
    },
    id: "eltsesoobcb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,472.8c-16.72-10.51-39.08-5.89-54.44-19.87a180.37,180.37,0,0,0,14.33-27.63c15,7.13,34,2.85,48.59,10.85A252.86,252.86,0,0,0,397,472.8Zm-53.1-19.91c15,12.55,36.16,8.74,52.36,18.2a260.56,260.56,0,0,1,8.09-34.32c-14.22-7.29-32.4-3.61-47-10.21A190,190,0,0,1,343.94,452.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "374.02px 449.05px"
    },
    id: "elwfbagozt7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.22,434c13.53,4.26,29.2,2.42,41.78,9.06a259.33,259.33,0,0,0-6.33,28.88c-14.15-8.58-32.21-6.67-46.66-14.39C354.1,449.87,357.83,442,361.22,434Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "376.505px 452.97px"
    },
    id: "elkdur83u6qm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,472.8c-14.41-9.07-33-6.88-47.73-15.07,4.27-7.91,8.16-16.06,11.66-24.33,13.78,4.43,29.82,2.39,42.59,9.35A255.94,255.94,0,0,0,397,472.8Zm-46.32-15.45c14.17,7.27,31.69,5.63,45.58,13.74a261.36,261.36,0,0,1,6.14-27.71c-12.4-6.32-27.69-4.7-41-8.78C358.2,442.31,354.62,449.92,350.72,457.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.395px 453.1px"
    },
    id: "el5iqz6ik0hlk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,457.8c-.31-.17-.63-.33-.94-.51a287.08,287.08,0,0,0,13.61-29.17l.88.24A309.05,309.05,0,0,1,350.48,457.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "356.785px 442.96px"
    },
    id: "eloslpy6zw1eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.24,461.24l-1-.31q6.93-15.46,12.92-31.17l.91.13Q366.08,445.64,359.24,461.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "365.155px 445.5px"
    },
    id: "elvz7qgcxttrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.46,463.45l-1-.21q6-16.28,12-32.52l.93.09Q374.41,447.1,368.46,463.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.925px 447.085px"
    },
    id: "elti613p5gpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.82,465.29l-1.05-.21q5.06-16.86,10.84-33.48l.92.13Q382.79,448.4,377.82,465.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.65px 448.445px"
    },
    id: "ela9tnvmxom2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,467.64l-1-.32c2.71-11.65,5.94-23,9.65-34.29l.88.22C392.83,444.52,389.64,455.93,387,467.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.265px 450.335px"
    },
    id: "elzegcs7rsvzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.85,443.6c-14.66-7.74-33.5-4-48.25-11.81l.39-.87c14.76,7.66,33.55,3.9,48.16,11.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "378.875px 437.26px"
    },
    id: "elxx253ynvu88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,450.71c-15-8-34.3-4.36-49.06-13.28.14-.28.28-.56.41-.85,14.76,8.74,34,5.09,48.92,13.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.605px 443.645px"
    },
    id: "el0j60f9qm9tdd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.3,458c-15.44-8.47-35.38-4.79-50.24-15,.15-.28.3-.55.44-.83,14.84,10,34.67,6.34,50,14.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "374.28px 450.085px"
    },
    id: "elneqiin90zd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,465.36c-15.95-9.16-36.76-5.28-51.77-17l.46-.8c15,11.48,35.65,7.64,51.53,16.68C398,464.61,397.88,465,397.81,465.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.035px 456.46px"
    },
    id: "elqhwayivioyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.3,176.19a378.69,378.69,0,0,1-56.07-24.36.57.57,0,0,0-.7.13,269.2,269.2,0,0,0-27.69,43.26.53.53,0,0,0,.25.66,410.87,410.87,0,0,1,53.5,39,.47.47,0,0,0,.71-.12,341.49,341.49,0,0,0,30.25-57.92A.5.5,0,0,0,450.3,176.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "408.197px 193.377px"
    },
    id: "el6y6545lhfz2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.59,234.91a410.87,410.87,0,0,0-53.5-39,.53.53,0,0,1-.25-.66A269.2,269.2,0,0,1,393.53,152a.57.57,0,0,1,.7-.13,378.69,378.69,0,0,0,56.07,24.36.5.5,0,0,1,.25.68,341.49,341.49,0,0,1-30.25,57.92A.47.47,0,0,1,419.59,234.91Zm-52.66-39.54a425.73,425.73,0,0,1,52.86,38.26,348,348,0,0,0,29.62-56.56,395.93,395.93,0,0,1-55.31-24.3A278.61,278.61,0,0,0,366.93,195.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.203px 193.42px"
    },
    id: "eltljfejtga9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.69,193.55q-29.34-14-57.41-29.61,4.17-6,8.67-11.76a386.05,386.05,0,0,0,56.14,24.53Q446.61,185.25,442.69,193.55Z",
    style: {
      fill: "current",
      transformOrigin: "417.685px 172.865px"
    },
    id: "elmj13k47ha9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91,194.28Q413.11,180,384.58,164.06q4.43-6.33,9.22-12.45a380,380,0,0,0,57,24.74Q447.09,185.44,442.91,194.28ZM386,163.83q27.6,15.35,56.48,29,3.68-7.77,7-15.75a395.93,395.93,0,0,1-55.31-24.3Q389.9,158.22,386,163.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.69px 172.945px"
    },
    id: "el3743563g866",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.92,173.7l-1.09-.55.48-1.21-1.33-.67-.85,1-1-.51,4.79-5.52,1.56.75Q412.2,170.33,410.92,173.7Zm-1.3-3.19,1,.52,1.35-3.35h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.305px 169.97px"
    },
    id: "el8xu75bxs7eg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.37,170.8l-.47.83a1.73,1.73,0,0,1-2.51.78l-.51-.25c-.46.78-.92,1.56-1.37,2.34l-1.09-.54,3.66-6.21,1.58.74A1.45,1.45,0,0,1,417.37,170.8Zm-1.74-1.65-1.23,2.11.51.25c.34.17.61.11.87-.34l.54-.94c.26-.45.16-.68-.18-.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.559px 171.125px"
    },
    id: "elgf4tjtku9eg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.42,177a2.16,2.16,0,0,1,.34-.84l.57-1c.33-.6.24-.92-.25-1.16l-.38-.18-1.47,2.6-1.09-.54c1.21-2.11,2.41-4.23,3.62-6.35l1.63.75c1.11.51,1.33,1.22.78,2.22l-.29.51a1.53,1.53,0,0,1-1.43,1v0c.43.47.34,1,0,1.71l-.55,1a2,2,0,0,0-.32.84Zm1.9-6.07c-.37.65-.74,1.31-1.1,2l.42.2c.4.19.74.14,1-.38.12-.21.24-.42.35-.63.26-.46.21-.74-.18-.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.3px 173.545px"
    },
    id: "el5mjmqs1g5gr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,171.27l1.09.49-3.57,6.57-1.1-.54C420.32,175.62,421.52,173.45,422.7,171.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "421.455px 174.8px"
    },
    id: "elwbvbt1l69f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.57,172.11l1.09.48q-1.52,2.86-3,5.71l1.8.86-.51,1-2.9-1.4C422.21,176.52,423.39,174.31,424.57,172.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.355px 176.135px"
    },
    id: "elsy1yef3vcve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.64,226.91a498.83,498.83,0,0,0-46.17-32.34Q379.24,182,387.14,170q24,13.45,48.69,26.24Q428,211.94,418.64,226.91Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "404.15px 198.455px"
    },
    id: "elo9wqpzppku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.77,227.7a490.5,490.5,0,0,0-46.95-33q6.94-13,15.12-25.31,24.45,13.68,49.59,26.61Q428.43,212.24,418.77,227.7Zm-45.64-33.24a509.79,509.79,0,0,1,45.38,31.66q9-14.49,16.62-29.65-24.19-12.63-47.78-25.86Q379.72,182.28,373.13,194.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "404.175px 198.545px"
    },
    id: "eloyp5tenynx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.92,178.52q20.81,11.86,41.81,23.74-6.57,12.57-14.09,24.65-19.18-15.12-39.51-28.15Q384.76,188.52,390.92,178.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "405.93px 202.715px"
    },
    id: "el0pvj8q55psg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.77,227.7a488.92,488.92,0,0,0-40.3-28.83q5.82-10.63,12.23-21Q412,190,433.44,202,426.62,215.14,418.77,227.7Zm-39-29q19.89,12.76,38.72,27.47,7.19-11.6,13.52-23.63-20.53-11.7-40.9-23.33Q385.22,188.79,379.79,198.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.955px 202.785px"
    },
    id: "el8es5hw6q9ek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,199.05l-.88-.57q7-12.69,14.75-25l.9.5Q386.57,186.33,379.57,199.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.515px 186.265px"
    },
    id: "elc4hmu3m6ftp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.37,204.17l-.87-.59q7.26-12.92,15-25.66l.9.49Q394.68,191.21,387.37,204.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "394.45px 191.045px"
    },
    id: "ela9ois535ikc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,209.44l-.86-.6,15.29-26.54.91.49Q402.78,196.14,395.09,209.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.33px 195.87px"
    },
    id: "elq7mlgfobkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.72,214.87l-.85-.62q8.08-13.68,15.75-27.6l.91.48Q410.85,201.14,402.72,214.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.2px 200.76px"
    },
    id: "eltrj9x3isxxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.28,220.46l-.85-.64Q418,205.63,425.75,191l.91.48Q418.92,206.2,410.28,220.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.045px 205.73px"
    },
    id: "elcpcrrob40w4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.48,202.74Q408.07,188.85,383.9,175c.15-.25.31-.5.47-.75Q408.54,188,433,201.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.45px 188.495px"
    },
    id: "el33g288szyen",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.08,209.08Q405,194.14,380.81,180c.15-.26.3-.51.46-.76q24.23,14.1,48.33,28.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.205px 194.16px"
    },
    id: "elnh903xq5ocl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.55,215.35Q402,199.45,377.81,185l.45-.77q24.19,14.37,47.83,30.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.95px 199.79px"
    },
    id: "el67lu6aehaj3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.91,221.56q-22.95-16.83-47-31.44l.44-.78q24.07,14.6,47.12,31.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.69px 205.45px"
    },
    id: "elx5blsexea6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,374.05a177.46,177.46,0,0,0-55.75-24.23.49.49,0,0,0-.59.39A150.08,150.08,0,0,1,60.74,405a.48.48,0,0,0,.15.7,192.22,192.22,0,0,0,61.75,22.87.49.49,0,0,0,.59-.4A141.42,141.42,0,0,1,142,374.74.52.52,0,0,0,141.83,374.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "101.357px 389.195px"
    },
    id: "elppo7643ny78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.64,428.54a192.22,192.22,0,0,1-61.75-22.87.48.48,0,0,1-.15-.7,150.08,150.08,0,0,0,24.75-54.76.49.49,0,0,1,.59-.39,177.46,177.46,0,0,1,55.75,24.23.52.52,0,0,1,.15.69,141.42,141.42,0,0,0-18.75,53.4A.49.49,0,0,1,122.64,428.54ZM62,405.06a196,196,0,0,0,60.31,22.39,147.87,147.87,0,0,1,18.64-52.82A181.76,181.76,0,0,0,86.31,351,156.19,156.19,0,0,1,62,405.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.35px 389.18px"
    },
    id: "elai1ht9462bi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.14,388.72a372.23,372.23,0,0,0-52.9-22A153.19,153.19,0,0,0,86,350.33a179.7,179.7,0,0,1,55.61,24.14A146.17,146.17,0,0,0,134.14,388.72Z",
    style: {
      fill: "current",
      transformOrigin: "111.425px 369.525px"
    },
    id: "elcxmey0dkr2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.34,389.37A386.29,386.29,0,0,0,80.64,367a150.93,150.93,0,0,0,5-17.33,177.79,177.79,0,0,1,56.63,24.62A143,143,0,0,0,134.34,389.37Zm-52.5-23a357.37,357.37,0,0,1,52.1,21.73,150.21,150.21,0,0,1,7-13.44A181.76,181.76,0,0,0,86.31,351,154.32,154.32,0,0,1,81.84,366.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.455px 369.52px"
    },
    id: "el1p1k1uuum3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.55,359.1c1,.35,1.34,1.26.9,2.52l-.08.24-1-.34c0-.11.08-.22.11-.33.19-.56.07-.84-.27-1s-.6,0-.79.6a2.46,2.46,0,0,0,.33,2A3.39,3.39,0,0,1,97,365.7c-.45,1.26-1.24,1.78-2.25,1.42s-1.29-1.26-.85-2.51c0-.16.11-.32.16-.48l1,.34-.2.56c-.19.56,0,.83.28,1s.6,0,.8-.57a2.39,2.39,0,0,0-.3-2,3.47,3.47,0,0,1-.33-2.85C95.75,359.29,96.51,358.75,97.55,359.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.1688px 363.114px"
    },
    id: "elu4uag0hu7ds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.62,363.64l1.43.52c-.13.38-.27.75-.4,1.12l-1.43-.52c-.27.77-.55,1.53-.83,2.3l1.78.66c-.14.37-.27.75-.41,1.12l-2.81-1q1.42-3.92,2.76-7.86l2.89,1-.39,1.13-1.82-.67C100.13,362.18,99.88,362.91,99.62,363.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.775px 364.41px"
    },
    id: "elam0mioq2oou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.65,364.35l-.38,1c-.47,1.26-1.24,1.74-2.27,1.34l-.49-.18c-.36,1-.73,2-1.1,2.94l-1-.39q1.47-3.91,2.86-7.86l1.56.58C105.86,362.21,106.12,363.09,105.65,364.35Zm-1.75-1.61c-.32.89-.64,1.78-1,2.66l.49.19c.33.13.58,0,.78-.54.15-.4.29-.79.44-1.18.21-.56.09-.81-.24-.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.143px 365.325px"
    },
    id: "el3ttn5y09m1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,362.48c1.08.42,2.16.85,3.23,1.29-.14.38-.29.75-.43,1.12l-1.09-.44q-1.28,3.36-2.58,6.7l-1-.4q1.31-3.36,2.56-6.72l-1.09-.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.23px 366.815px"
    },
    id: "elsvuoay4lqsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,367.68l1.41.59-.45,1.11-1.4-.59-.9,2.28,1.75.74-.44,1.11-2.77-1.15c1-2.6,2-5.21,3-7.81,1,.39,1.89.79,2.83,1.2-.15.36-.29.73-.44,1.1l-1.78-.75C110.55,366.23,110.27,367,110,367.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "110.115px 368.44px"
    },
    id: "elh28qe4sbnql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.62,371.86h0c1-1.73,2-3.44,3-5.16l1.43.66c-1.08,2.54-2.16,5.09-3.22,7.65l-1-.42q1.14-2.76,2.29-5.51h0q-1.48,2.6-3,5.21l-1-.41,1.5-5.79h0l-2.23,5.47-.88-.37c1-2.59,2.09-5.17,3.13-7.75l1.43.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.28px 370.225px"
    },
    id: "el1ghq2ti8sj1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,370.89l-.12.27c-.34.78-.75,1.16-1.31,1.2v0a1.76,1.76,0,0,1,.06,2l-.27.62c-.5,1.16-1.28,1.55-2.28,1.09l-1.58-.71q1.59-3.82,3.23-7.63l1.54.73C121.34,369,121.54,369.74,121,370.89Zm-1.73-1.61c-.29.66-.58,1.33-.86,2l.39.19c.38.17.69.09,1-.52l.19-.42c.23-.54.18-.85-.18-1ZM118,372.37l-1,2.33.58.27c.33.15.59,0,.83-.51l.29-.66c.3-.71.2-1-.26-1.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.395px 371.994px"
    },
    id: "eldwlbqsdjvx6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,373.16l1.38.67-.48,1.06-1.37-.66-1,2.19,1.72.82-.46,1.06L119.21,377c1.08-2.51,2.17-5,3.29-7.51l2.76,1.39c-.17.35-.33.7-.49,1.05l-1.74-.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.235px 373.895px"
    },
    id: "el5m2fmof0mhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.61,379.6a3,3,0,0,1,.31-.94l.52-1.15c.31-.68.23-1-.22-1.26l-.35-.17c-.45,1-.9,2-1.34,3l-1-.47q1.62-3.72,3.34-7.39l1.51.79c1,.55,1.22,1.34.69,2.45l-.27.57c-.35.74-.78,1.11-1.33,1.12v0a1.75,1.75,0,0,1,0,1.88l-.51,1.12a2.6,2.6,0,0,0-.29.94Zm1.78-6.82c-.35.75-.7,1.5-1,2.25l.39.2c.37.18.68.11,1-.47.12-.24.23-.48.34-.72.24-.52.2-.83-.16-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.44px 375.655px"
    },
    id: "elcold8n8oqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63,422.44a215.64,215.64,0,0,1-50.38-18.88A189.32,189.32,0,0,0,83.57,373q22.64,8.28,44.68,18.35A181.43,181.43,0,0,0,118.63,422.44Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "98.25px 397.72px"
    },
    id: "elbohqhdia1bu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,423.05a212.58,212.58,0,0,1-51.5-19.27,183.93,183.93,0,0,0,15.82-31.47q23.09,8.37,45.51,18.72A177.45,177.45,0,0,0,119,423.05ZM69,403.33a218.25,218.25,0,0,0,49.27,18.49,186.56,186.56,0,0,1,9.39-30.23q-21.66-9.81-43.84-18A193.41,193.41,0,0,1,69,403.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.165px 397.68px"
    },
    id: "elixfxe96r0e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.36,381.54q19.29,7.71,38.61,15.61a181.3,181.3,0,0,0-7.34,25.29A215.45,215.45,0,0,1,75,407,274.24,274.24,0,0,0,87.36,381.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "100.485px 401.99px"
    },
    id: "el06ky6qq2umam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,423.05a212.71,212.71,0,0,1-44.73-15.83,264.57,264.57,0,0,0,12.86-26.34q19.71,7.83,39.41,16A178.11,178.11,0,0,0,119,423.05ZM75.72,406.7a219,219,0,0,0,42.53,15.12,187.43,187.43,0,0,1,7.12-24.37q-18.93-7.68-37.8-15.24Q82.26,394.69,75.72,406.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.405px 401.965px"
    },
    id: "el5a2kyk9rsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.46,407.18l-.9-.44a265.73,265.73,0,0,0,14.92-31.59l.84.32A279.11,279.11,0,0,1,75.46,407.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.44px 391.165px"
    },
    id: "elwffptrvp76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,410.87l-.92-.4Q90.43,394.47,97,378l.84.33Q91.26,394.8,83.6,410.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "90.26px 394.435px"
    },
    id: "elsb5i4rzzmed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,414.21l-.94-.36Q97.81,397.46,104.4,381l.84.34Q98.64,397.78,91.88,414.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.09px 397.605px"
    },
    id: "el3kq0llzr0yf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3,417.21l-1-.32q5.9-16.56,12.46-32.81l.83.35Q106.1,400.65,100.3,417.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.945px 400.645px"
    },
    id: "elmm80uzr8hl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.86,419.87l-1-.28a342.28,342.28,0,0,1,11.3-32.33l.83.36A319.63,319.63,0,0,0,108.86,419.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "113.925px 403.565px"
    },
    id: "ele969hro8frb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.79,397.62q-22.5-9.14-44.93-18.1c.14-.32.28-.64.41-1q22.46,8.86,44.87,18.13C126,397,125.91,397.3,125.79,397.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.5px 388.07px"
    },
    id: "el5t7xlwhiotp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.61,403.9q-23.19-8.28-45.66-18l.45-.95q22.46,9.61,45.53,18C123.82,403.26,123.72,403.58,123.61,403.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.94px 394.425px"
    },
    id: "elg12n688c758",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.66,410.27A371.53,371.53,0,0,1,74.8,392.12c.16-.31.33-.62.49-.94a400.94,400.94,0,0,0,46.65,18.13C121.85,409.63,121.76,410,121.66,410.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.37px 400.725px"
    },
    id: "elvvause0ah0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,416.74A260.62,260.62,0,0,1,71.4,398.28c.18-.31.36-.62.53-.93a272.22,272.22,0,0,0,48.26,18.41C120.11,416.09,120,416.41,119.94,416.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "95.795px 407.045px"
    },
    id: "elqxvyy4im7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.29,152.6a.5.5,0,0,0-.44-.56,317.45,317.45,0,0,0-68.35-5,.45.45,0,0,0-.43.56,250.32,250.32,0,0,1,5.06,63,.49.49,0,0,0,.43.55,270.17,270.17,0,0,0,58.23-4.3.54.54,0,0,0,.44-.54A212.36,212.36,0,0,1,126.29,152.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "91.6752px 179.078px"
    },
    id: "elxbnqbc0219h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.79,206.77a270.17,270.17,0,0,1-58.23,4.3.49.49,0,0,1-.43-.55,250.32,250.32,0,0,0-5.06-63,.45.45,0,0,1,.43-.56,317.45,317.45,0,0,1,68.35,5,.5.5,0,0,1,.44.56,212.36,212.36,0,0,0-5.06,53.63A.54.54,0,0,1,120.79,206.77ZM63.07,210a278.59,278.59,0,0,0,57.23-4.08,221.84,221.84,0,0,1,4.82-53.07,323.93,323.93,0,0,0-66.87-4.79A258.44,258.44,0,0,1,63.07,210Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.6752px 178.998px"
    },
    id: "el3c1aba7e0pk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,167.59a595.18,595.18,0,0,0-62.37-2.23q-1.19-8.9-3-17.82a320.63,320.63,0,0,1,68.14,5Q124.1,160,123,167.59Z",
    style: {
      fill: "current",
      transformOrigin: "91.7px 157.475px"
    },
    id: "elu55ruf2j2pd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.41,168.09a614.17,614.17,0,0,0-63.21-2.18Q58.94,156.48,57,147a316.74,316.74,0,0,1,69.43,5.12Q124.61,160.1,123.41,168.09ZM61,164.81a579.39,579.39,0,0,1,61.53,2.27c.69-4.75,1.55-9.48,2.56-14.22a323.93,323.93,0,0,0-66.87-4.79Q59.92,156.45,61,164.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.715px 157.439px"
    },
    id: "eleh7wetq73x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,155.08h0q.28,3,.52,6H74c-.23-2.78-.49-5.57-.77-8.35l1.57,0q.87,2.51,1.68,5h0c-.12-1.66-.26-3.32-.41-5l1.12,0c.23,2.78.43,5.56.62,8.33H76.61C76,159.13,75.31,157.11,74.61,155.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.52px 156.905px"
    },
    id: "elghwwhua0k7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.18,154.85c-.1-1.33.52-2.08,1.75-2A2,2,0,0,1,82,155c.08,1.43.15,2.87.22,4.31s-.55,2.06-1.73,2-1.88-.8-2-2.13S78.29,156.3,78.18,154.85Zm1.52,4.44c0,.59.3.82.68.83s.62-.21.59-.8c-.08-1.5-.17-3-.26-4.49,0-.59-.3-.82-.7-.83s-.63.2-.59.8C79.52,156.3,79.61,157.79,79.7,159.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.1974px 157.079px"
    },
    id: "elq79i4ml652o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.79,159.81h0q.33-3.36.68-6.7l1.16.06c-.33,2.72-.64,5.45-1,8.18l-1.79,0q-.76-4.16-1.6-8.32l1.27.05Q84.23,156.42,84.79,159.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "84.435px 157.19px"
    },
    id: "eltmn8da7ddd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,156.72l1.69.08c0,.39,0,.78,0,1.17l-1.69-.08c0,.8,0,1.6,0,2.4l2.1.09c0,.39,0,.78,0,1.16l-3.29-.13c-.07-2.73-.13-5.47-.21-8.22l3.43.19c0,.39,0,.78,0,1.17l-2.16-.12C88.54,155.19,88.55,156,88.57,156.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.92px 157.365px"
    },
    id: "elqsgly4p81kp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.05,159.35h0q.44-2.85.9-5.69l1.75.13-.18,8-1.14-.06.09-5.79h0c-.31,1.91-.61,3.83-.9,5.74l-1.14-.05q-.44-2.89-.88-5.79h0c0,1.91,0,3.83,0,5.74l-1,0c0-2.72,0-5.43,0-8.15l1.75.11Q93.63,156.45,94.05,159.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.125px 157.61px"
    },
    id: "elt8cszi7zdin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,156v.28c0,.82-.31,1.31-.87,1.53v0a1.64,1.64,0,0,1,.84,1.75l0,.65A1.62,1.62,0,0,1,99.32,162l-1.9-.11q.09-4,.21-8l1.9.16A1.67,1.67,0,0,1,101.3,156Zm-2.45-.9c0,.71,0,1.41-.07,2.12l.48,0c.46,0,.75-.15.77-.78,0-.15,0-.3,0-.45,0-.56-.16-.83-.6-.87Zm-.11,3.26c0,.81,0,1.63-.08,2.45l.7,0c.41,0,.63-.15.66-.74l0-.69c0-.74-.2-1-.75-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.3722px 157.963px"
    },
    id: "el1cmvdw94pqz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.33,157.69l1.7.14c0,.38,0,.75-.07,1.12l-1.69-.14c0,.77-.09,1.53-.13,2.3l2.1.16c0,.37,0,.74-.07,1.11l-3.29-.23q.18-3.94.39-7.89c1.14.1,2.29.21,3.43.33,0,.37,0,.74-.08,1.11l-2.16-.2C103.42,156.23,103.37,157,103.33,157.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.79px 158.32px"
    },
    id: "elblcz6lr8cwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.45,162.63a2.32,2.32,0,0,1,0-.95c0-.41.07-.81.1-1.21.06-.71-.16-1-.72-1.05l-.43,0c-.08,1.05-.16,2.1-.23,3.15l-1.21-.1c.17-2.58.35-5.17.56-7.76l1.9.2c1.3.14,1.81.79,1.69,2l-.06.6a1.5,1.5,0,0,1-1,1.46v0c.59.31.74.9.67,1.69,0,.39-.07.79-.1,1.18a2.07,2.07,0,0,0,.05.94Zm-.81-6.73c-.06.8-.13,1.59-.19,2.38l.48,0c.46.05.76-.12.81-.74,0-.25.05-.5.07-.76,0-.54-.12-.81-.56-.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.043px 158.745px"
    },
    id: "elduxqcsd82tk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,202.69a320.82,320.82,0,0,1-49,3,297.68,297.68,0,0,0-1.26-35q25.77-.15,51.73,1.2A271.1,271.1,0,0,0,116.24,202.69Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "91.845px 188.202px"
    },
    id: "elr6d237wqpgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,203.11a316.8,316.8,0,0,1-50,3.13,293,293,0,0,0-1.33-36.1q26.3-.18,52.8,1.3A265.87,265.87,0,0,0,116.7,203.11Zm-49,2.06a328.29,328.29,0,0,0,48.12-2.89,277.25,277.25,0,0,1,1.35-29.94q-25.42-1.25-50.67-1.12A301.54,301.54,0,0,1,67.66,205.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.77px 188.202px"
    },
    id: "elyjsyddn4zh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.57,177.45q21.69,0,43.55.37-1,12.42-.88,24.87a322.19,322.19,0,0,1-42.18,3.05Q74.3,191.63,73.57,177.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "95.345px 191.595px"
    },
    id: "elt6mwjhh0a6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,203.11a317.59,317.59,0,0,1-43.1,3.17q.27-14.64-.53-29.37,22.2,0,44.56.44Q116.54,190.21,116.7,203.11Zm-42.17,2.08a329.26,329.26,0,0,0,41.25-2.91q-.11-12,.82-24Q95.26,178,74.07,178,74.73,191.64,74.53,205.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "95.35px 191.595px"
    },
    id: "elryt930xgqy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.52,205.73h-.91q.3-17.48-.93-35.08h1Q74.81,188.27,74.52,205.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "73.6296px 188.19px"
    },
    id: "elyk7s3q2k8wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.66,205.57l-.92,0q.2-17.39-.49-34.88h1Q82.84,188.21,82.66,205.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.976px 188.13px"
    },
    id: "el5dfjk794z0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8,205.19l-.92.06q.11-17.16,0-34.39l1,0Q90.88,188.08,90.8,205.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "90.38px 188.055px"
    },
    id: "elvtuskgavxhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.94,204.61l-.91.08q0-16.77.4-33.61l1,0Q98.94,187.9,98.94,204.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.73px 187.885px"
    },
    id: "el3481lrfndv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,203.83l-.91.09q-.09-16.26.85-32.53l1,0Q107,187.63,107.09,203.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.101px 187.655px"
    },
    id: "el8514aj2vfcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.08,178.3Q91.7,178,66.53,178c0-.36,0-.73-.07-1.09q25.23,0,50.69.43C117.13,177.66,117.1,178,117.08,178.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.805px 177.605px"
    },
    id: "elyuy4d0tfej8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.65,184.59q-24.95.66-49.7.58c0-.36,0-.72,0-1.08q24.8.06,49.8-.45C116.69,184,116.67,184.27,116.65,184.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.85px 184.409px"
    },
    id: "elyhe7mm79b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,190.89q-24.68,1.63-49.17,1.45l0-1.09q24.52.17,49.23-1.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.815px 191.149px"
    },
    id: "el64em07jxci4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23,197.2a420.89,420.89,0,0,1-49,2.29v-1.08a446.88,446.88,0,0,0,49-2.16C116.24,196.57,116.24,196.89,116.23,197.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.7338px 197.884px"
    },
    id: "elxj8da86sqdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrpelc438zr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.29,385.85c-1.83,5.4-4.29,13.69-5,20.71-.91,9-17.58,22.59-24.8,28.09A166.09,166.09,0,0,0,169,410.79a.38.38,0,0,1,.25-.57C185.07,405.87,196.8,394.31,210.29,385.85Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "189.617px 410.25px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2ho5iqidluy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.41,409.34c-4.28,9.24-14.54,28.82-26.64,33.62-15.1,6-19.22,1.86-22.43-9.91A163.37,163.37,0,0,0,359.59,405a.39.39,0,0,1,.55-.26C371.37,410,385,408,397.41,409.34Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "372.875px 425.196px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elur9kj6mpqo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.47,112.58s2,1.72-.42,6.23q-9.36-2.52-18.49-6a.47.47,0,0,1-.25-.66,156,156,0,0,0,8.41-20.55c.37-.2.75-.38,1.14-.56,5.51-2.51,6.44,4,6.44,4s4.64-.07,6.07,2.06c2.34,3.47-1.66,6.62-1.66,6.62S406.05,107.5,399.47,112.58Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "391.68px 104.637px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-21",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "249.99px 267.386px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.1,419.54c-3.43,5.88-23.43-3.76-23.06-16s20.63-9.29,20.63-9.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "174.567px 407.624px"
    },
    id: "el7f6xyod1kn3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.36,394.3s-5.93,10.68-8.83,12.39l6.85,22.82,16.49-24.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "177.2px 411.905px"
    },
    id: "elppfwunqmsz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.38,399.8c2.33,2.15-13,23.35-17.32,19.74s3.3-18.39,7.12-20.89S356.38,399.8,356.38,399.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "347.196px 408.864px"
    },
    id: "els8b6yvowjml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,394.3S354.1,405,357,406.69l-6.86,22.82-16.48-24.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "345.33px 411.905px"
    },
    id: "el47iey2z2v4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.63,255.49c2.64,7.51,36-2.33,50.51,0s29.74-9.36,25.48-20.33-43.41-23.24-43.41-23.24l-26.11,8.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "253.989px 235.143px"
    },
    id: "el2u5qohixbgu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,246.34s-2.25-14.24,0-22.55-46-16.13-46-16.13L222.1,228.14s2,8.76,0,26.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "252.468px 231.165px"
    },
    id: "eliscnya6m4va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "252.468px 229.39px"
    },
    id: "elr94wm8g6ohp",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elv15qpbfv2e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.76,223.79c-1.27,4.69-1.11,11.26-.73,16.1a90.76,90.76,0,0,0-59.57,11.24c1.35-15.39-.36-23-.36-23l14.63-20.48S285,215.48,282.76,223.79Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "252.468px 229.39px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,246.34s-2.25-14.24,0-22.55-46-16.13-46-16.13L222.1,228.14s2,8.76,0,26.53Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "252.468px 231.165px"
    },
    id: "elt44du0k4myg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,246.75s35.87-4.84,62.77-2.1L287.37,263s32.7,70,38.51,82.86,30.5,53.94,30.5,53.94-12.83-2.07-17.32,19.74c0,0-50.11-66-54.33-73.68S255,300,255,300h-7.19s-26.32,46.81-28.43,50.66S194,405,186.1,419.54c0,0-9.81-28.58-23.06-16,0,0,10.92-28.79,12-29.2s5.7-22.55,8.65-26.25S218.27,263,218.27,263Z",
    style: {
      fill: "rgb(117, 117, 117)",
      transformOrigin: "259.71px 331.675px"
    },
    id: "el68i17jcx0qf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "261.78px 349.925px"
    },
    id: "elq1t7p2gflmj",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "el0pm0r07708ni"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.7,416.81c-.23.86-.44,1.77-.64,2.73,0,0-50.11-66-54.33-73.68S255,300,255,300h-7.19s-26.32,46.81-28.43,50.66S194,405,186.1,419.54a54.3,54.3,0,0,0-2.24-5.33s11.4-19.84,12.26-26.95-10-.61-11.7-5.05,23.07-13.59,29.29-29.39c0,0-6.32.58-7.57-9.78s36.88-49.35,46.3-54.4c-.53.16-12.18,3.79-10.7,1s10.18-9.33,10.18-9.33,7.56,7.74,17.45,7.7-8.72,5.5-8.72,5.5,23.76,27.68,34.84,30.06-15,1.25-15,1.25,30.71,50.23,47.6,60.1,9.07,15.24,8.43,20.27C336.17,407.59,337.86,412.42,339.7,416.81Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "261.78px 349.925px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,246.75s35.87-4.84,62.77-2.1L287.37,263s32.7,70,38.51,82.86,30.5,53.94,30.5,53.94-12.83-2.07-17.32,19.74c0,0-50.11-66-54.33-73.68S255,300,255,300h-7.19s-26.32,46.81-28.43,50.66S194,405,186.1,419.54c0,0-9.81-28.58-23.06-16,0,0,10.92-28.79,12-29.2s5.7-22.55,8.65-26.25S218.27,263,218.27,263Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "259.71px 331.675px"
    },
    id: "el3j9lk3gb6j2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,111s19.22,11.88,30.61,16.36l-9.26,12.83s-22.7-17.43-29.58-21",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "143.62px 125.595px"
    },
    id: "el2iiibfy9bfy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.8,113c1.17-1.71.64-4.22.34-5.42a12.45,12.45,0,0,0-1.32-3.22,17.09,17.09,0,0,1-1.33-2.83c-.25-.66-.46-1.33-.66-2a38.54,38.54,0,0,1-.94-4s-2.08-.73-2.37,1.34a5.84,5.84,0,0,0,.06,1.71c.16,1,.46,2,.65,2.76a2.53,2.53,0,0,1,.07,1.42,2,2,0,0,1-.3.49.32.32,0,0,0,0,.06l-.13.17a2.55,2.55,0,0,1-1,.72,1.58,1.58,0,0,1-.52.12.31.31,0,0,1-.14,0,2.91,2.91,0,0,1-.4-.05,7.22,7.22,0,0,1-2-.76h0a22.6,22.6,0,0,1-2.65-1.73h0c-.31-.24-.62-.48-.91-.73a28,28,0,0,1-2.16-1.93c-.48-.49-1-1-1.55-1.5s-1.06-.94-1.58-1.34c-1.52-1.16-2.89-1.75-3.38-.58s.08,1.53,1.3,2.67c.42.4.93.88,1.51,1.49a29,29,0,0,1,2.78,3.43h0l.33.47-.45.62c.08.12-.19,0-.7-.21h0A35.15,35.15,0,0,1,110.5,102c-.57-.38-1.15-.79-1.73-1.22s-1-.78-1.52-1.19c-2.47-2-3.06.29-2.65,1.31a8.19,8.19,0,0,0,2.43,2.28c.57.42,1.16.86,1.72,1.29.28.21.54.42.79.63,1,.86,2.1,1.73,2.85,2.34l.29.23-.26,1-.46-.11h0a23.84,23.84,0,0,1-3.87-1.37c-.85-.4-1.49-.76-2-1-1-.51-1.49-.68-2.11-.11s0,1.66,1,2.58a10.58,10.58,0,0,0,2.82,1.73h0a4,4,0,0,0,.56.18,11.54,11.54,0,0,1,2.73,1.32l.52.32.18.79-.85-.1h0a23,23,0,0,1-2.67-.5h0a21.58,21.58,0,0,0-2.15-.49,1.16,1.16,0,0,0-1.21.42c-.42.62.23,1.32,1.22,1.88a9.61,9.61,0,0,0,1.89.81,6.11,6.11,0,0,0,1.5.29,12.63,12.63,0,0,1,2.78.71l1.11.4c1.32.49,2.54,1,3,1.18l.16.07c.88.57,1.64,1,2.32,1.42a12.33,12.33,0,0,0,5.26,1.74c1,.11,2.17-.65,3.36-1.75",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "118.128px 107.952px"
    },
    id: "elkbmvyzenaae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,104.43s-2.9,3.5-.54,6.9",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "123.467px 107.88px"
    },
    id: "elclqttkuijbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.57,110.26S348.35,122.14,337,126.62l9.26,12.84s22.7-17.44,29.58-21",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "356.42px 124.86px"
    },
    id: "ele5pplkoq3fl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.2,112.3c-1.17-1.71-.64-4.22-.34-5.42a12.39,12.39,0,0,1,1.32-3.21,17.59,17.59,0,0,0,1.33-2.84c.25-.66.46-1.33.66-2a37.89,37.89,0,0,0,.94-4s2.08-.72,2.37,1.35a5.78,5.78,0,0,1-.06,1.7c-.16,1-.46,2-.65,2.76a2.56,2.56,0,0,0-.07,1.43,2.22,2.22,0,0,0,.3.49.12.12,0,0,1,0,0l.13.17a2.55,2.55,0,0,0,1,.72,1.58,1.58,0,0,0,.52.12.31.31,0,0,0,.14,0,2.91,2.91,0,0,0,.4,0,7.22,7.22,0,0,0,2-.76h0a20.31,20.31,0,0,0,2.65-1.73h0l.91-.73a27.86,27.86,0,0,0,2.16-1.94c.48-.49,1-1,1.55-1.5s1.06-.94,1.58-1.34c1.52-1.15,2.89-1.74,3.38-.57s-.08,1.53-1.3,2.67c-.42.4-.93.87-1.51,1.48a29.87,29.87,0,0,0-2.78,3.43h0l-.33.48.45.61c-.08.12.19,0,.7-.21h0a35.59,35.59,0,0,0,3.83-2.29c.57-.37,1.15-.78,1.73-1.21s1-.79,1.52-1.2c2.47-2,3.06.29,2.65,1.31a8.19,8.19,0,0,1-2.43,2.29c-.57.42-1.16.85-1.72,1.28l-.79.63c-1,.86-2.1,1.74-2.85,2.34l-.29.24.26,1,.46-.12h0a22.92,22.92,0,0,0,3.87-1.37c.85-.39,1.49-.76,2-1,1-.51,1.49-.69,2.11-.11s0,1.66-1,2.57a10.62,10.62,0,0,1-2.82,1.74h0c-.2.08-.39.14-.56.19a11.06,11.06,0,0,0-2.73,1.31l-.52.32-.18.79c.3,0,.58-.06.85-.09h0a25.12,25.12,0,0,0,2.67-.51h0a17.07,17.07,0,0,1,2.15-.49,1.14,1.14,0,0,1,1.21.42c.42.61-.23,1.31-1.22,1.88a9,9,0,0,1-1.89.8,6.71,6.71,0,0,1-1.5.3,12.08,12.08,0,0,0-2.78.71l-1.11.4c-1.32.48-2.54,1-2.95,1.17l-.16.07c-.88.58-1.64,1-2.32,1.42a12.35,12.35,0,0,1-5.26,1.75c-1,.11-2.17-.65-3.36-1.76",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "381.862px 107.187px"
    },
    id: "elxxy0iedf19n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.8,103.69s2.9,3.51.54,6.9",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "376.533px 107.14px"
    },
    id: "elt0le6nebig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.3,103.48s-1.35-5.83-5.52-8.11c-5.94-3.24-15-2.07-15-2.07s3.47,1.78,4.46,3.85c0,0-2.08-1.18-5.74,0a6.64,6.64,0,0,1-6.13-.89s-.7,4.67,1.48,5.9-.1.43-.1.43-1.88,2.48-3.56,2.08c0,0,.1,5.14,1.58,7,0,0-1.68,2.42-1.58,4.13a2.3,2.3,0,0,1-1.58,2.25s.49,3.34,1.78,4.22c0,0-1,6.22,1,9.48a84.76,84.76,0,0,0,5,7.12s-.49,2.24-1.68,2.41c0,0,1.68,3.62,9.5,1.35,0,0,10.59,3,14,1.15a16.14,16.14,0,0,0,6.81,1.12s-.58-4,.71-5.63a68.88,68.88,0,0,0,6.42-7.52c1.78-2.77.89-10.39.89-10.39s1.69-2,1.39-3.31c0,0-1.48.45-2.18-.54,0,0,1.39-3,2.67-3.56,0,0-.29-3.17-2.57-4,0,0,1.58-2.77,3.07-3.16,0,0-5.38-2.28-8.28,0a8.28,8.28,0,0,1,3.93-6s-4.57.2-6.05,4c0,0-2.95-8.31-2.36-11.47A18.16,18.16,0,0,0,256.3,103.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.015px 119.008px"
    },
    id: "elrq108ooj9op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.05,146.14s4,12.66-1.32,20.57c0,0,12.4,4.49,23,0a28.68,28.68,0,0,1-3.38-20.57S248.6,140.87,238.05,146.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "248.23px 156.252px"
    },
    id: "el85cp1hls6zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1,252.47a147.15,147.15,0,0,1,17.21-1.58v-4.55s-12.47.4-17.21,2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.705px 249.405px"
    },
    id: "elrivf8ikql5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,146.56a12.17,12.17,0,0,0,7.56,4.2c4.8.59,7.19-4.2,7.19-4.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.575px 148.685px"
    },
    id: "elt4bae398quo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.26,126.34s1.77-1.87,2.76,0-.91,11.17-4,10.18",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "263.152px 131.051px"
    },
    id: "ele57t7v0jy7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.07,126.34s-1.76-1.87-2.75,0,.91,11.17,4,10.18",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "231.188px 131.051px"
    },
    id: "eld4z8cxlbxck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,108.82c8.7,0,13.45,5.74,13.85,7.32a75.08,75.08,0,0,1,1.38,13.65,34.43,34.43,0,0,1-4.94,15.33c-2.07,3.41-16.46,3.23-19.59.1-2.87-2.87-6.13-12.81-5.93-15.3s.92-12,1.38-13.71C234.1,112.78,238.91,108.82,247,108.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "246.996px 128.221px"
    },
    id: "elqgcz73a8hyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.66,116.54a6.76,6.76,0,0,0-6.93,3.16",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "240.195px 118.071px"
    },
    id: "el2aiymbnvkfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.78,116.44s4.17-2.18,6.93,1.63",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "254.245px 116.945px"
    },
    id: "elufa23arq5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88,122.67s-2.57,1.38-4.16,1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "239.8px 123.203px"
    },
    id: "elwldzeuoc5tj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,121.88a13.83,13.83,0,0,0,4.34.79",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "254.17px 122.275px"
    },
    id: "elp4usd2832fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.45,126.82s1.38-3.22,2.57-3.09,2.76,3.09,2.76,3.09",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "247.115px 125.273px"
    },
    id: "elnym9424dey",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.8,132.49s10.88,1.85,15.92-.72",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "247.76px 132.452px"
    },
    id: "elpees5karlhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.06,132.7a7,7,0,0,0,6.55,3.82c4.95,0,7.34-4.41,7.34-4.41",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "248.005px 134.318px"
    },
    id: "elzdnhih0fh0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.47,153.77s6.3-1.66,20.81,3.63c0,0,20.77-3.58,29,0a49,49,0,0,1,18.77-5s27.43-14.29,35.34-17.09,20.05-10.15,23.74-12.81,14.24-5.82,14.24-5.82a14.77,14.77,0,0,1,5.27-3.63s12.14,11.59,11.08,18.43l-4.22,1.29S290,185,287.37,186.69c-1.32.86,1.55,5.93.79,19.3-.83,14.7,6.53,26.67,4.19,34.53,0,0-7.23-11.62-29.18-10.53-18,.89-47.54,25.5-47.54,25.5a84.36,84.36,0,0,1,.18-22.33c2.2-15.57.35-38.34.35-41.59,0-5.27-70.68-48.89-70.68-48.89l-3.69-.92-9.5-7.61s6.33-20.45,16.88-18.27l9,6.34,11.34,6.09S200.34,148.67,212.47,153.77Z",
    style: {
      fill: "current",
      transformOrigin: "251.538px 184.27px"
    },
    id: "eltpzmk10q8ve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "253.33px 187.82px"
    },
    id: "el9txjfqnvjli",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elwcparm4wwh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.77,130.81c0,.23,0,.44-.06.66l-4.22,1.29s-76,51.9-79.09,53.91l0-4.37s35.38-23.07,42.12-31.49,7.22-2.13,7.22-2.13,23.61-13.08,24.87-24.33A13.38,13.38,0,0,1,370.77,130.81Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "329.085px 155.51px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloirqkxh4wbd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.07,191.2c-2.78-6.67-70.59-48.52-70.59-48.52l-3.69-.92-5.9-4.72c1.62-10.07,9.38-12.18,9.38-12.18s.08,11,2.85,15.33,47.87,31,47.87,31-2.77-12.41,4.15-2.5,13.72,11.17,13.72,11.17A73.08,73.08,0,0,1,216.07,191.2Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "175.98px 158.03px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli2mczks3px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.24,226.91a6.57,6.57,0,0,0,5.27,6.32c4,.83,6.8,4.89-17.31,18.06a88,88,0,0,1,.61-18.13c1.43-10.11,1.15-23.26.78-32.13,6.89,6.36,18.07,13.83,30.56,10.89C267.79,207.07,252.56,227.76,227.24,226.91Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "235.89px 226.16px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M212.47,153.77s6.3-1.66,20.81,3.63c0,0,20.77-3.58,29,0a49,49,0,0,1,18.77-5s27.43-14.29,35.34-17.09,20.05-10.15,23.74-12.81,14.24-5.82,14.24-5.82a14.77,14.77,0,0,1,5.27-3.63s12.14,11.59,11.08,18.43l-4.22,1.29S290,185,287.37,186.69c-1.32.86,1.55,5.93.79,19.3-.83,14.7,6.53,26.67,4.19,34.53,0,0-7.23-11.62-29.18-10.53-18,.89-47.54,25.5-47.54,25.5a84.36,84.36,0,0,1,.18-22.33c2.2-15.57.35-38.34.35-41.59,0-5.27-70.68-48.89-70.68-48.89l-3.69-.92-9.5-7.61s6.33-20.45,16.88-18.27l9,6.34,11.34,6.09S200.34,148.67,212.47,153.77Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "251.538px 184.27px"
    },
    id: "eld8c35thtoqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.74,246.34v4s13.85-.93,21.37,0v-4.88S246.89,244.89,241.74,246.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.425px 247.845px"
    },
    id: "elfb1rtnew4ki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,245.32l.53,5s12.79-.4,17,.79l-.92-4.75A51.32,51.32,0,0,0,266.14,245.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.905px 248.086px"
    },
    id: "elny0m5jmeno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.15,246.73v2.91a1.45,1.45,0,0,0,1.45,1.45h6.86a1.45,1.45,0,0,0,1.45-1.45v-3.11a1.46,1.46,0,0,0-1.49-1.45l-6.86.2A1.46,1.46,0,0,0,247.15,246.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "252.03px 248.085px"
    },
    id: "elce9kfylc3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,250.3s.86,27.29-.49,44.7",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "251.89px 272.65px"
    },
    id: "elbfx58rvm91",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,249.9s.92,7.65,0,11.87c0,0,2.84,11.34-2.87,12.53",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "254.248px 262.1px"
    },
    id: "elheptzap9q44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.16,296.71A65.86,65.86,0,0,1,257.71,295",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "248.935px 295.832px"
    },
    id: "el1ypfzge62sx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8,253.07s3.43,9.19,8.57,9.93",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.085px 258.035px"
    },
    id: "elv598wn8kfdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,253.73s-2,7.08-6.73,9.27",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "221.635px 258.365px"
    },
    id: "eluc92s520bl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,284.85s-27,22.15-34.68,22.68",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "223.88px 296.19px"
    },
    id: "elq9m0kcdaut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,296.71s8.77,0,20,12.93c7.81,9,33.1,15.95,33.1,15.95",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "275.49px 311.15px"
    },
    id: "elfmfjq2njwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.76,300s-10.37,2.94-15.25,7.56",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "240.135px 303.78px"
    },
    id: "elq5a9l5tzhx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,374.39s15.3.65,24.79-10.95",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "187.395px 368.918px"
    },
    id: "elejygf6ih6l7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.21,359.75s24,23.73,38,28.22",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "327.21px 373.86px"
    },
    id: "eln3w9i2wa2zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.52,396.54s-.28-7.24-7.62-7.41-11.48,11.48-11.48,11.48-6.2,1-8.14,7.12-1.59,9.36-1.59,9.36-2.47,1.19-3.18,5.35c-1.05,6.14,1.27,8.46,1.27,8.46,3.21,10.2,10.32,11.91,12.67,10.2C367.21,436.17,378.52,396.54,378.52,396.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "362.379px 415.403px"
    },
    id: "elfxsmverp6ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,433c.95-3.63,2.84-6.93,4-10.52,1.6-5,1.7-10.36,2.62-15.54s4-10.95,7.74-14.07c5.15-4.28,11.06-.94,11.21,6.32.17,8-3.41,17.91-6.25,25.25-2.64,6.79-11.55,22.75-19,14.21-.95-1.08-.91-2.9-.6-4.46C353.1,433.78,353.2,433.38,353.3,433Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "365.849px 416.039px"
    },
    id: "el0uoj0geoi4lg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.4,
    y1: 401.91,
    x2: 378.74,
    y2: 402.47,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "370.07px 402.19px"
    },
    id: "el1hybd2voirnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.52,
    y1: 406.61,
    x2: 378.09,
    y2: 407.07,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "368.305px 406.84px"
    },
    id: "el9h17ym1cq6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.76,
    y1: 411.11,
    x2: 377.06,
    y2: 411.35,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "367.41px 411.23px"
    },
    id: "el6qsc62hfyxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.71,
    y1: 414.73,
    x2: 375.82,
    y2: 415.52,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "366.765px 415.125px"
    },
    id: "elsid3smlfx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.99,
    y1: 419,
    x2: 374.45,
    y2: 419.52,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "365.72px 419.26px"
    },
    id: "el21zs55p64sz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.21,
    y1: 423.55,
    x2: 372.61,
    y2: 424.43,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "364.41px 423.99px"
    },
    id: "el7hxzdfwlzng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.12,
    y1: 427.74,
    x2: 370.73,
    y2: 428.58,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "362.425px 428.16px"
    },
    id: "el098tcx4pnjhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.3,
    y1: 432.99,
    x2: 367.59,
    y2: 433.88,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "360.445px 433.435px"
    },
    id: "elm1ojofok79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352,
    y1: 436.34,
    x2: 364.4,
    y2: 437.81,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "358.2px 437.075px"
    },
    id: "eltx2k1jp29jq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.14,
    y1: 396.15,
    x2: 378.4,
    y2: 397.22,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "370.77px 396.685px"
    },
    id: "elanqpj24u6yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,396.54s.28-7.24,7.61-7.41,11.48,11.48,11.48,11.48,6.2,1,8.14,7.12,1.59,9.36,1.59,9.36,2.47,1.19,3.18,5.35c1.06,6.14-1.27,8.46-1.27,8.46-3.21,10.2-10.32,11.91-12.66,10.2C155.31,436.17,144,396.54,144,396.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.138px 415.403px"
    },
    id: "el31sdl79acd5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.22,433c-.95-3.63-2.84-6.93-4-10.52-1.6-5-1.69-10.36-2.62-15.54s-4-10.95-7.74-14.07c-5.14-4.28-11.05-.94-11.21,6.32-.17,8,3.41,17.91,6.26,25.25,2.63,6.79,11.54,22.75,19,14.21.94-1.08.9-2.9.6-4.46C169.42,433.78,169.33,433.38,169.22,433Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "156.672px 416.039px"
    },
    id: "elceco4eubjks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.12,
    y1: 401.91,
    x2: 143.78,
    y2: 402.47,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "152.45px 402.19px"
    },
    id: "eln7c1e99gsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 406.61,
    x2: 144.44,
    y2: 407.07,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "154.22px 406.84px"
    },
    id: "elkz33m1asg39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.76,
    y1: 411.11,
    x2: 145.47,
    y2: 411.35,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "155.115px 411.23px"
    },
    id: "el96yxh6dpqsw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.81,
    y1: 414.73,
    x2: 146.7,
    y2: 415.52,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "155.755px 415.125px"
    },
    id: "el59kfonldeks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.54,
    y1: 419,
    x2: 148.07,
    y2: 419.52,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "156.805px 419.26px"
    },
    id: "elak4v39xx7qc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.31,
    y1: 423.55,
    x2: 149.92,
    y2: 424.43,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "158.115px 423.99px"
    },
    id: "elrva3nl5l69c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.41,
    y1: 427.74,
    x2: 151.8,
    y2: 428.58,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "160.105px 428.16px"
    },
    id: "elxvzlsgzbqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.22,
    y1: 432.99,
    x2: 154.93,
    y2: 433.88,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "162.075px 433.435px"
    },
    id: "elfzzneacto5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.53,
    y1: 436.34,
    x2: 158.12,
    y2: 437.81,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "164.325px 437.075px"
    },
    id: "el2ws5a251dgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.38,
    y1: 396.15,
    x2: 144.12,
    y2: 397.22,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "151.75px 396.685px"
    },
    id: "elxb92os1i1fh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.37,186.69s.81-23.29-4.54-30.44",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "285.122px 171.47px"
    },
    id: "elw1lf2azpjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.35,159.37s.16,14.09-5,20.51",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "289.85px 169.625px"
    },
    id: "el1mwsprd0k17h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,191.57S211.47,172.37,213,163",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "214.427px 177.285px"
    },
    id: "elraqmqcbiojm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.47,153.77s-7.25,6.45-5.93,14.94",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "209.425px 161.24px"
    },
    id: "ely82ispy1fpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.36,116.67a38.76,38.76,0,0,1,8.81,10.18",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "358.765px 121.76px"
    },
    id: "elq3li55cgqgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.92,139.46s1.68-12,9.2-17.17",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "143.52px 130.875px"
    },
    id: "elqsb3qxq0fvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.83,202.82s-34.28,25.35-51.66,24.35",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "257px 215.009px"
    },
    id: "elowg3wloy0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.24,179.88s14.5,16.31,35.93,19.08",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "245.205px 189.42px"
    },
    id: "elojd6d7oyqv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--calendar-top--inject-21",
    className: "animable",
    style: {
      transformOrigin: "247.518px 202.025px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elup8lb9fym8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.65,343l.38,25.4s2.48-3.49,20.81-2.1l-1.2,4.07s29.49,5.09,41.86-.9l.36-5.12-2.67-1.65s3.31-41.14,2.67-57.16c0,0-37.62,15.22-51.57,11.07S60.65,343,60.65,343Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "91.6247px 338.964px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpmsxu9b42w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.57,316.08l-5.31,64.66s7.93-9.83,22.64-7.78l2.37,4.62s28,9.27,37.59,9.68c0,0-5-42.51-12.56-52.9S323.57,316.08,323.57,316.08Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "349.56px 351.67px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el78m37y6d9ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.36,245.32l53.13-41.15s30.42,44.26,42.25,47.41c0,0-12.71,30.51-59.72,44.24C396,295.82,371.44,253.32,360.36,245.32Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "408.05px 249.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elps99hzcjitp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.44,80.34s20.87,8.45,36.38,22.59c0,0,31.94-21.74,42.32-22.59,0,0-18-33-32.49-45.59C320.65,34.75,283.85,64.57,274.44,80.34Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "313.79px 68.84px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnxcgoug512o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.07,60.25s12,32.25,11.16,45.32a47.68,47.68,0,0,0,28.08-8.08,31.71,31.71,0,0,1,27.09-4.4s-5-32.12,0-41.44c0,0-3.24-4.18-21-3.87S159.4,60,153.07,60.25Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "186.235px 76.6784px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqcfpaahvdzb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.91,88.32c.89-.26,34.63,25.58,47.61,28.31,0,0-30.43,41.56-54.33,57.87,0,0-18.88-35.27-37.78-42.05C40.41,132.45,56.57,96.32,84.91,88.32Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "86.465px 131.409px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.45,78.86a253.45,253.45,0,0,1-9.3-48.78,1,1,0,0,0-.55-.66C186.39,18.79,173.28,48.3,150.06,42c-.33-.08-.51,0-.39.3a298.83,298.83,0,0,1,19.5,54.88,1.15,1.15,0,0,0,.6.7c20.67,8.31,30.66-23.14,50.34-18.72C220.36,79.24,220.52,79.09,220.45,78.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "185.05px 63.1862px"
    },
    id: "elqas4o4un6eq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.11,79.19c-19.68-4.42-29.67,27-50.34,18.72a1.15,1.15,0,0,1-.6-.7,298.83,298.83,0,0,0-19.5-54.88c-.12-.25.06-.38.39-.3,23.22,6.27,36.33-23.24,60.54-12.61a1,1,0,0,1,.55.66,253.45,253.45,0,0,0,9.3,48.78C220.52,79.09,220.36,79.24,220.11,79.19ZM170,97.14c20.17,7.56,30.14-22.81,49.38-18.84a264.47,264.47,0,0,1-9.24-48.24c-23.61-9.8-36.55,18.72-59.08,13A308.8,308.8,0,0,1,170,97.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.05px 63.1972px"
    },
    id: "eldni2x2rwvow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.32,43.84c-22.23-8.94-33.73,21-55.47,13.88q-3.07-7.66-6.58-15.23c23.18,6.3,36.23-23.22,60.37-12.64Q211.29,36.89,212.32,43.84Z",
    style: {
      fill: "current",
      transformOrigin: "181.295px 43.1818px"
    },
    id: "elpwbww367vs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,44.45C190.23,34.86,178.75,65.81,156.48,58q-3.25-8.13-7-16.14c12.92,3.65,20.85-2.49,30.36-7.81,9.19-5.37,20-9.91,31.31-4.4Q211.78,37.1,212.87,44.45Zm-55.66,13c21.22,6.4,32.73-22.48,54.56-14.18q-1-6.55-1.61-13.17c-23.61-9.8-36.55,18.72-59.08,13Q154.33,50.2,157.21,57.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.175px 43.2115px"
    },
    id: "elcpcff0ntmpt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,52.23l.35-.14c.31-.14.52-.39.34-1Q171,48.36,170,45.58c.34-.16.68-.31,1-.48.61,1.83,1.22,3.65,1.82,5.48.48,1.46-.07,2.17-.82,2.5a3.67,3.67,0,0,1-.48.19C171.43,52.92,171.31,52.57,171.2,52.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.5px 49.185px"
    },
    id: "elxrigkau61qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24,50.28l-1,.57c-.19-.4-.39-.81-.58-1.22l-1.2.67c.09.47.17.94.26,1.41l-.9.47q-.67-3.9-1.37-7.81c.49-.25,1-.52,1.47-.79C175.07,45.81,176.17,48.05,177.24,50.28Zm-2.94-1,.94-.52c-.54-1.14-1.09-2.29-1.65-3.43h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "174.845px 47.88px"
    },
    id: "elv1zvasevv0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,44.2h0c.54,1.75,1.08,3.51,1.61,5.26l-.86.54c-.75-2.43-1.5-4.85-2.26-7.28l1.25-.74c.78,1.25,1.55,2.49,2.31,3.74h0c-.43-1.45-.87-2.9-1.31-4.35l.9-.55c.71,2.42,1.43,4.84,2.13,7.26l-1,.63Q178.36,46.46,177,44.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "178.13px 45.41px"
    },
    id: "elxh3g2oyrc1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.26,39.79q.81,2.81,1.6,5.59c.15.52.4.58.71.38a.83.83,0,0,0,.31-1q-.8-2.77-1.57-5.57l1-.58c.51,1.83,1,3.67,1.51,5.5a2.29,2.29,0,0,1-.95,2.74c-.94.62-1.63.27-2-.89-.54-1.84-1.07-3.68-1.61-5.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.61px 42.8813px"
    },
    id: "elxq3endi64rj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.14,43.47c-.34.19-.68.38-1,.58l-.52-1.21-1.22.73.18,1.41-.91.56q-.48-3.91-.92-7.82l1.52-.85Q186.71,40.17,188.14,43.47Zm-2.88-.95,1-.57c-.47-1.12-.95-2.24-1.43-3.36h0C184.93,39.9,185.09,41.21,185.26,42.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.945px 41.205px"
    },
    id: "eld80molf80nt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,42.1a2.13,2.13,0,0,1-.31-.83c-.09-.37-.18-.74-.26-1.12-.16-.66-.43-.8-.9-.57l-.36.18c.23,1,.47,1.94.71,2.91l-1,.54c-.6-2.39-1.19-4.77-1.78-7.16.53-.27,1.06-.53,1.6-.78,1.12-.52,1.73-.17,2,.92,0,.19.09.37.13.56a1.77,1.77,0,0,1-.37,1.74v0c.58,0,.88.45,1.05,1.19.09.36.17.73.26,1.09a2,2,0,0,0,.31.81Zm-2.61-5.55c.17.73.35,1.46.53,2.19l.41-.2a.82.82,0,0,0,.45-1.06c-.05-.23-.11-.47-.17-.7-.12-.51-.33-.66-.71-.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.33px 39.1217px"
    },
    id: "elzz40rg7bmni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.72,38.64q-1.2-2.1-2.43-4.19c.38-.16.77-.31,1.15-.45L193,36.92h0c0-1.17.09-2.34.15-3.5l1.08-.32c-.17,1.7-.3,3.41-.42,5.15l.51,2.33-1.06.41C193.07,40.2,192.9,39.42,192.72,38.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "192.305px 37.045px"
    },
    id: "elrqumq6jnbhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,74.64c-15.7-.29-25.27,21.88-41.48,19.68q-4-15.6-9.5-30.9c16.65,1.76,27.24-19.42,44.78-16.55Q210.85,60.9,214.56,74.64Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "189.07px 70.5379px"
    },
    id: "elt7zcpbxnqck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.12,75.06c-16.09-.64-25.73,22.38-42.37,19.66q-4.12-16.08-9.82-31.83C180,65.11,190.75,43.12,208.76,46.5Q211.28,60.93,215.12,75.06ZM173.41,93.9c15.78,1.71,25.28-19.62,40.61-19.68q-3.59-13.35-6.05-27c-17.08-2.37-27.56,18-43.74,16.7Q169.48,78.78,173.41,93.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.025px 70.5447px"
    },
    id: "el3stiluzrix3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,68.93c12.53-3.33,22.56-18.63,37.06-16.66q2.2,11.28,5.19,22.37c-13.49-.13-22.48,16-35,19.35Q176.27,81.39,172.31,68.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "193.435px 73.0428px"
    },
    id: "el739ap55gy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.12,75.06c-13.87-.43-23,16.32-35.86,19.51q-3.39-13.08-7.53-26c12.89-3.13,23.1-19.06,38-16.65Q212,63.57,215.12,75.06ZM179.83,93.4c12.18-3.6,21.06-19,34.19-19.18q-2.88-10.69-5-21.56c-14.09-1.56-23.94,13.13-36.13,16.64Q176.67,81.29,179.83,93.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.425px 73.1214px"
    },
    id: "elyz918vuzrxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,93.88c-.27.08-.54.15-.82.21q-4-15.61-9.19-31c.29-.07.57-.13.85-.21Q175.89,78.28,180,93.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "174.995px 78.485px"
    },
    id: "elqo0x6u9gk4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.85,90.61l-.74.48Q182,75.6,177.19,60.17l.78-.44Q182.7,75.14,186.85,90.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.02px 75.41px"
    },
    id: "el7qpca102dhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,85.74l-.71.58q-4.18-15.27-8.54-30.56l.77-.53Q189.13,70.5,193.3,85.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "188.675px 70.775px"
    },
    id: "eluar4gicd11n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.68,80.63l-.72.55q-4.1-14.94-7.94-30l.81-.47Q195.61,65.75,199.68,80.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "195.35px 65.945px"
    },
    id: "elq22bny7ou8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.36,76.58l-.77.37q-3.93-14.49-7.15-29.17c.29-.1.58-.18.87-.26Q202.46,62.16,206.36,76.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.4px 62.235px"
    },
    id: "el4y5ovn3ome6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45,52.7c-17-2.34-27.25,19-43.65,17.11-.1-.32-.21-.63-.32-1,16.43,1.88,26.71-19.45,43.81-17C209.34,52.13,209.4,52.41,209.45,52.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.465px 60.7712px"
    },
    id: "el9ah8hi3ua0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63,58.4c-16.58-1.82-26.54,19.72-42.77,17.71-.1-.32-.2-.64-.31-1,16.26,2,26.25-19.51,42.89-17.61C210.51,57.83,210.57,58.12,210.63,58.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.09px 66.8118px"
    },
    id: "elau2dszqy0df",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.9,64.08c-16.2-1.3-26,20.45-42.11,18.35-.09-.32-.19-.64-.28-1,16.16,2.09,25.94-19.62,42.2-18.24C211.77,63.51,211.84,63.8,211.9,64.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.705px 72.8499px"
    },
    id: "elgh22du2tsjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.28,69.74c-15.9-.76-25.53,21.2-41.68,19-.08-.32-.17-.64-.26-1C187.48,90,197.12,68,213.07,68.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "192.31px 78.8746px"
    },
    id: "elrul4pi2d8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.06,74.21v-.06c-.08-.31-.17-.6-.25-.91s-.17-.66-.26-1-.23-.78-.35-1.17-.19-.64-.29-1L352.52,69l-.33-.94c-.13-.37-.28-.74-.42-1.1l-.36-.93c-.14-.36-.3-.71-.45-1.06l-.39-.91L350.09,63c-.14-.29-.27-.59-.42-.88s-.34-.69-.51-1-.29-.58-.44-.86-.35-.67-.53-1-.31-.57-.46-.85l-.56-1-.48-.84-.58-1-.51-.83c-.19-.31-.39-.62-.59-.93s-.35-.55-.52-.82-.42-.62-.62-.93-.35-.54-.53-.8l-.64-.92-.54-.79-.64-.9L341,47.9l-.67-.92-.55-.75L339,45.16l-1.21-1.62-.47-.61-1-1.28-.28-.37-1.26-1.65-.23-.31c-.34-.44-.68-.88-1-1.33-.17-.22-.34-.43-.5-.65l-.75-1-.56-.76-.68-.9c-.19-.25-.38-.51-.56-.77s-.45-.6-.66-.9l-.57-.78-.64-.89-.56-.81c-.21-.3-.42-.59-.62-.89l-.56-.83-.59-.88c-.19-.28-.38-.57-.56-.86l-.57-.88c-.18-.29-.36-.57-.53-.86s-.38-.6-.56-.91-.35-.58-.52-.87l-.54-.92-.5-.9q-.25-.45-.51-.93l-.47-.91c-.17-.31-.33-.63-.49-.95l-.45-.93c-.19-.41-.39-.81-.58-1.22q-1.82,1.8-3.64,3.56l-.25.24q-1.59,1.53-3.18,3l-1,.91c-.83.77-1.65,1.53-2.48,2.28l-1.18,1.08L306,30a267.77,267.77,0,0,1-37.71,28.22.55.55,0,0,0-.24.71c9.84,17.79,29.15,28.76,42.15,44a.46.46,0,0,0,.65.07A198.56,198.56,0,0,1,342.17,81l.94-.54c1.62-.9,3.25-1.79,4.89-2.64l.65-.34q2.39-1.23,4.79-2.4l.75-.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "311.096px 59.9466px"
    },
    id: "elpin1t2l607b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.17,102.86c-13-15.2-32.31-26.17-42.15-44a.55.55,0,0,1,.24-.71c18.26-11.21,35-24.83,51.31-41,.23-.23.52-.2.64.07,9.43,20.27,28.09,33.53,33.85,56.86a.67.67,0,0,1-.25.74,199.09,199.09,0,0,0-43,28A.46.46,0,0,1,310.17,102.86Zm-41-44.11C279,76.09,297.78,87,310.56,101.91A209.86,209.86,0,0,1,353.14,74c-6-22.57-24.1-35.7-33.54-55.39C303.54,34.27,287.1,47.63,269.19,58.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.03px 59.9832px"
    },
    id: "ellk8wg1huf2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.07,81c-8-19.73-25.58-32.11-35.2-50.32q7-6.21,13.92-13c9.44,20.19,28,33.43,33.88,56.64C349.44,76.39,345.23,78.63,341.07,81Z",
    style: {
      fill: "current",
      transformOrigin: "329.77px 49.34px"
    },
    id: "elksxrhrqfm5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.88,81.71c-8.07-20.07-26-32.52-35.67-51.07,5-4.38,9.89-9,14.78-13.84,9.43,20.71,28.56,34,34.2,57.9C349.72,76.84,345.27,79.18,340.88,81.71Zm-34.36-51c9.6,17.88,26.75,30.19,34.74,49.59q5.89-3.41,11.88-6.36c-6-22.57-24.1-35.7-33.54-55.39Q313.1,24.94,306.52,30.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "329.7px 49.255px"
    },
    id: "eloweyv2ivh6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,38.15l.93,1.23-.93.77-.93-1.23c-.9.75-1.79,1.49-2.69,2.22l-.72-.93q3.27-2.7,6.51-5.46c.63.87,1.27,1.73,1.91,2.58l-.93.77-1.19-1.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "321.33px 37.945px"
    },
    id: "elsqf3trtjhoa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.89,41c.33.44.67.87,1,1.3L324,43c-.34-.42-.68-.85-1-1.28L321,43.3l1.28,1.6-.93.74q-1-1.26-2-2.52,3.27-2.64,6.51-5.32l2,2.63-.93.75-1.28-1.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.605px 41.72px"
    },
    id: "elu6avm2ebvga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,45.05l-.23.18a1.67,1.67,0,0,1-1.79.41h0c.18.67-.14,1.24-.84,1.77l-.53.41a1.74,1.74,0,0,1-2.69-.19l-1.18-1.44c2.19-1.71,4.36-3.44,6.53-5.18l1.14,1.45A1.6,1.6,0,0,1,329.12,45.05Zm-.93-2.33-1.72,1.36.29.36c.28.35.62.44,1.14,0l.37-.29c.46-.36.55-.67.28-1Zm-2.66,2.09-2,1.58.42.52c.26.31.55.35,1,0l.57-.44c.61-.48.65-.8.31-1.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "325.94px 44.689px"
    },
    id: "elq2dlzc9u8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.18,51.48a2.75,2.75,0,0,1,.74-.69c.34-.26.68-.52,1-.77.6-.46.68-.82.34-1.24-.09-.11-.18-.21-.26-.32l-2.67,2-.75-.91,6.54-5L332.29,46a1.56,1.56,0,0,1-.4,2.54l-.51.39a1.72,1.72,0,0,1-1.81.37h0c.16.63-.2,1.14-.88,1.65l-1,.75a2.49,2.49,0,0,0-.71.7ZM331,46.22l-2,1.53c.1.12.2.24.29.37.28.35.62.43,1.15,0l.64-.49c.47-.35.56-.65.29-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.679px 48.475px"
    },
    id: "elnzvnwtbtnch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,49l-5,3.71c-.46.34-.48.65-.25,1s.56.35,1,0l5-3.66c.24.3.47.61.7.91l-5,3.59a1.83,1.83,0,0,1-2.75-.19c-.73-.9-.52-1.81.53-2.58l5-3.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.959px 51.582px"
    },
    id: "elvb5oyjie2xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.4,59.25l-.73-1,1.05-1-.89-1.15-1.3.68-.68-.85c2.42-1.25,4.84-2.49,7.27-3.69q.53.71,1.05,1.44Zm.41-3.6.7.91,2.95-2.77v0C335.23,54.39,334,55,332.81,55.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.01px 55.745px"
    },
    id: "eliqo3ddr2pmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,61.68a2.37,2.37,0,0,1,.73-.63l1-.69c.6-.4.69-.75.37-1.19l-.24-.34c-.88.6-1.76,1.2-2.63,1.81-.24-.32-.47-.64-.71-1,2.15-1.5,4.32-3,6.49-4.48.35.5.7,1,1,1.52a1.55,1.55,0,0,1-.48,2.49l-.51.34a1.55,1.55,0,0,1-1.74.22h0c.13.64-.24,1.12-.91,1.57l-1,.67a2.32,2.32,0,0,0-.71.63C334.67,62.33,334.44,62,334.2,61.68ZM339,56.84l-2,1.36.28.38c.25.37.58.48,1.09.13l.64-.43c.46-.31.56-.6.32-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.682px 58.88px"
    },
    id: "elkub1b1lg9oq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,62.6l3.46-4.11q.35.52.69,1.08l-2.44,2.68,0,0c1.13-.38,2.27-.75,3.4-1.11l.6,1q-2.54.67-5.08,1.44L336.51,65l-.67-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339.775px 61.745px"
    },
    id: "elct8igkwnuxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.76,96.43c-11.26-12.56-26.23-22.56-35.6-36.6A317.1,317.1,0,0,0,304,38.38C313.05,52.8,326.82,63.83,335.2,79A257.45,257.45,0,0,0,310.76,96.43Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "305.18px 67.405px"
    },
    id: "elunaj4qtvk7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,97.07c-11.44-12.82-26.83-22.93-36.27-37.33a310.36,310.36,0,0,0,29.7-22.13c9.17,14.79,23.29,26,31.68,41.58A253.65,253.65,0,0,0,310.71,97.07ZM275.89,59.92c9.28,13.69,23.85,23.57,34.92,35.86a268.89,268.89,0,0,1,23.76-17c-8.36-14.75-21.78-25.62-30.78-39.69A325.4,325.4,0,0,1,275.89,59.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.13px 67.34px"
    },
    id: "elqnmgrc24d6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.63,48.56C311.41,60,322.69,69.7,330.35,82.14c-6.71,4.43-13.26,9.19-19.59,14.29-9.68-10.8-22.11-19.7-31.35-30.91Q291.29,57.45,302.63,48.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "304.88px 72.495px"
    },
    id: "elijw9v3zew18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,97.07C300.84,86,288,77,278.65,65.46c8.25-5.57,16.27-11.44,24.13-17.61,8.91,11.76,20.5,21.62,28.2,34.44C324,86.85,317.25,91.78,310.71,97.07Zm-30.55-31.5c9.1,10.91,21.16,19.68,30.65,30.21Q320,88.45,329.71,82c-7.6-12.06-18.58-21.56-27.23-32.72Q291.54,57.79,280.16,65.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.815px 72.46px"
    },
    id: "elmh6xezddc7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.71,65.88l-.6-.73q14.75-10,28.64-21.27l.57.77Q294.39,55.87,279.71,65.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.715px 54.88px"
    },
    id: "elcbbxr4x84wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,72.13l-.67-.69Q299.14,61.36,313,50.53l.62.73Q299.73,62,285.41,72.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "299.18px 61.33px"
    },
    id: "elqriyi8eiqgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.56,78l-.71-.65Q304.77,67.29,318.59,57l.63.72Q305.4,68,291.56,78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.035px 67.5px"
    },
    id: "elzgfe09klnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.88,83.82l-.71-.65q13.35-10,27-19.72c.21.24.41.49.61.73Q311.16,73.85,297.88,83.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.975px 73.635px"
    },
    id: "el2c97mgm1wuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14,89.63l-.69-.66q12.68-9.8,26-18.83c.19.25.37.51.56.77Q316.77,79.86,304.14,89.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.73px 79.885px"
    },
    id: "els7sfu55gr9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,82.39C321,68,307.21,57.26,298.12,43.15l.87-.7c9.09,14.15,22.88,24.92,31.75,39.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.43px 62.42px"
    },
    id: "elftmyzk9p0t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.9,85.84c-9.53-13.77-23.48-24.24-32.6-38.16l.89-.68c9.11,14,23,24.45,32.47,38.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.98px 66.42px"
    },
    id: "elcvh9uxx02g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,89.41c-10.11-13.24-24.31-23.5-33.49-37.36l.9-.65c9.16,13.86,23.32,24.15,33.34,37.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "303.53px 70.405px"
    },
    id: "elnsbheo3gx3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,93.11c-10.72-12.83-25.29-22.93-34.55-36.83l.91-.63c9.25,13.89,23.75,24,34.38,36.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.095px 74.38px"
    },
    id: "elss9vstcw9yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.72,261.24c-13.72-15.76-23.26-33.82-29.61-53.64a.44.44,0,0,0-.63-.28c-19.79,10-38.24,20-58,29.27a.47.47,0,0,0-.24.64,155.66,155.66,0,0,1,18.12,52,.59.59,0,0,0,.65.43A126.28,126.28,0,0,0,452.6,262,.55.55,0,0,0,452.72,261.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "408.507px 248.468px"
    },
    id: "elszzzkt7bl3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.6,262A126.28,126.28,0,0,1,383,289.64a.59.59,0,0,1-.65-.43,155.66,155.66,0,0,0-18.12-52,.47.47,0,0,1,.24-.64c19.73-9.23,38.18-19.26,58-29.27a.44.44,0,0,1,.63.28c6.35,19.82,15.89,37.88,29.61,53.64A.55.55,0,0,1,452.6,262Zm-69.14,26.6a126.56,126.56,0,0,0,68-27.05c-13.28-15.71-22.68-33.53-29.08-53-19.33,9.88-37.5,19.7-56.9,28.64A161.76,161.76,0,0,1,383.46,288.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.503px 248.448px"
    },
    id: "elvlruaiws2t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.82,224.17c-18.26,10.71-37.13,20-57.14,26.82q-3.14-7.12-6.94-14c19.73-9.15,38.18-19.16,57.9-29.18A172.83,172.83,0,0,0,428.82,224.17Z",
    style: {
      fill: "current",
      transformOrigin: "396.78px 229.4px"
    },
    id: "elicugifewzuj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.47,224.4c-18.52,10.93-37.71,20.39-58.08,27.18A163.5,163.5,0,0,0,364,236.82c20.07-9.37,38.78-19.57,58.91-29.73A168.39,168.39,0,0,0,429.47,224.4Zm-57.51,26c19.66-6.79,38.21-16,56.21-26.46q-3.26-7.49-5.83-15.36c-19.33,9.88-37.5,19.7-56.9,28.64Q369,243.68,372,250.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.735px 229.335px"
    },
    id: "elcye5sefxmmu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.57,234.83h0q-.82-2.83-1.66-5.7l1.51-.75L397.8,236l-1,.49c-.8-1.81-1.61-3.62-2.41-5.42h0l1.68,5.76-1,.48q-1.58-2.47-3.16-4.93h0q1.2,2.64,2.37,5.3l-.95.44q-1.67-3.75-3.36-7.47l1.51-.74C392.46,231.52,393.52,233.18,394.57,234.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.885px 233.25px"
    },
    id: "el6qr4feuf5co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.08,233.87l-1.09.53-.8-1.29-1.32.65.42,1.47-1,.48c-.75-2.71-1.51-5.42-2.26-8.14l1.58-.8Zm-3.53-1.21,1-.51c-.74-1.2-1.47-2.41-2.21-3.6h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "399.055px 231.24px"
    },
    id: "elifaj53nezyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,230.82l-3.6-4.43,1.13-.58,2.34,3.09h0c-.24-1.31-.48-2.61-.71-3.92l1-.53q.42,2.92.87,5.84l1.11,2.54-1.07.54C402.73,232.51,402.35,231.66,402,230.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.27px 228.91px"
    },
    id: "eldkel9xbrs0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.55,261.21a128.15,128.15,0,0,1-56.95,22.9,190.66,190.66,0,0,0-9.48-30.3,239.91,239.91,0,0,0,48.7-22.42A183.7,183.7,0,0,0,444.55,261.21Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "411.335px 257.75px"
    },
    id: "elwkbem1zp4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.34,261.3a127.72,127.72,0,0,1-58.2,23.37,186.35,186.35,0,0,0-9.68-31.15A246.17,246.17,0,0,0,427,230.66,179.54,179.54,0,0,0,445.34,261.3ZM388,283.54a128.34,128.34,0,0,0,55.71-22.43,189.12,189.12,0,0,1-17.14-29,235.2,235.2,0,0,1-47.83,22A195,195,0,0,1,388,283.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "411.4px 257.665px"
    },
    id: "elmns5vrpb8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.59,257.25a195,195,0,0,0,42.2-19.87,181.37,181.37,0,0,0,14.76,23.83A127.64,127.64,0,0,1,396,282.62Q392.4,269.68,387.59,257.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "416.07px 260px"
    },
    id: "eliw2qmxvr59s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.34,261.3a127.28,127.28,0,0,1-49.78,21.93,265.13,265.13,0,0,0-8.64-26.3A198.38,198.38,0,0,0,430,236.64,177.82,177.82,0,0,0,445.34,261.3ZM396.4,282a127.94,127.94,0,0,0,47.35-20.9,186.69,186.69,0,0,1-14.14-23,191.86,191.86,0,0,1-41.36,19.45Q392.87,269.56,396.4,282Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.13px 259.935px"
    },
    id: "ellg1r2pqutna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.54,282.51l-1.11.23a267.07,267.07,0,0,0-10.67-31.23l.94-.34A277.94,277.94,0,0,1,396.54,282.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390.65px 266.955px"
    },
    id: "elft1woqvm9w4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.42,280l-1.11.32q-5.55-16.26-12.23-32l.93-.38Q400.72,263.72,406.42,280Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "399.75px 264.13px"
    },
    id: "elixo53q118hd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.14,276.66l-1.09.41q-6.76-16.21-13.77-32.26l.91-.42Q409.23,260.47,416.14,276.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.71px 260.73px"
    },
    id: "el44y6phkzl7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.61,272.51l-1.05.51q-8-15.9-15.23-32l.89-.45Q417.54,256.66,425.61,272.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.47px 256.795px"
    },
    id: "el224yhhsn6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.76,267.58l-1,.59a344.4,344.4,0,0,1-16.52-31.34l.88-.48A322.42,322.42,0,0,0,434.76,267.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "426px 252.26px"
    },
    id: "eloezsssntna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,237.86A192,192,0,0,1,380.5,260c-.12-.31-.23-.61-.34-.92a197.67,197.67,0,0,0,49.39-22.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.08px 248.475px"
    },
    id: "el2gqhg383sum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.44,244.08a163.23,163.23,0,0,1-50.81,22l-.31-.93a166.64,166.64,0,0,0,50.59-22C433.08,243.46,433.26,243.77,433.44,244.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "407.88px 254.615px"
    },
    id: "elv0j350or2w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.08,250.17a145.28,145.28,0,0,1-52.52,22.11c-.1-.31-.19-.63-.28-.94a147.22,147.22,0,0,0,52.23-22.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.68px 260.77px"
    },
    id: "eltpo3e0x5ggi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,256.13a133.86,133.86,0,0,1-54.69,22.44l-.24-1a135.4,135.4,0,0,0,54.33-22.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.535px 266.885px"
    },
    id: "elsrxv7st4lgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.84,304.94c-.06-.3-.29-.37-.51-.17-18.93,14.81-38.28-6.4-57.89,4.79a1.21,1.21,0,0,0-.59.72,324.13,324.13,0,0,0-6.05,52.47c0,.25.23.31.53.15,23.55-12.37,46.79,14.62,70.26,6.65a.92.92,0,0,0,.57-.78A345.5,345.5,0,0,0,377.84,304.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "348.48px 337.853px"
    },
    id: "elxf47maydao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.59,369.55c-23.47,8-46.71-19-70.26-6.65-.3.16-.54.1-.53-.15a324.13,324.13,0,0,1,6.05-52.47,1.21,1.21,0,0,1,.59-.72c19.61-11.19,39,10,57.89-4.79.22-.2.45-.13.51.17a345.5,345.5,0,0,1,6.32,63.83A.92.92,0,0,1,383.59,369.55Zm-69.68-7.83c23.16-11.53,46,14.31,69.11,6.93a353.07,353.07,0,0,0-5.91-62.44c-18.84,13.88-38-6.53-57.35,4A335.76,335.76,0,0,0,313.91,361.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.48px 337.858px"
    },
    id: "el1jl738rpre9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,323.06c-21.08,13.11-42.23-9.71-63.49,1.69q1.11-7.38,2.53-14.74c19.67-11.2,39.07,10.06,58.08-4.7Q379.06,314.15,380.31,323.06Z",
    style: {
      fill: "current",
      transformOrigin: "348.565px 316.285px"
    },
    id: "elq61fvnvsty9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.86,323.26c-21.43,13.9-43-9.94-64.63,2.22q1.17-7.83,2.71-15.65c20-11.9,39.64,10.23,58.8-5.43Q379.53,313.79,380.86,323.26Zm-63.45.78c20.85-10.68,41.61,11.16,62.35-1.2q-1.14-8.34-2.65-16.63c-18.84,13.88-38-6.53-57.35,4Q318.47,317.12,317.41,324Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.545px 316.083px"
    },
    id: "elp4lb9pf6ibp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,318.15l.4.09c.37.07.67,0,.69-.54.06-1.81.13-3.61.2-5.42l1.12.23c-.05,1.78-.11,3.57-.16,5.35,0,1.43-.85,1.61-1.73,1.43a4.35,4.35,0,0,1-.57-.13C340.92,318.82,340.93,318.49,341,318.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "342.172px 315.814px"
    },
    id: "elnokmk091l2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.2,312.9l-.09,5.53a.74.74,0,0,0,.59.84c.38.08.61,0,.62-.56l.06-5.55,1.07.24c0,1.83,0,3.66,0,5.5,0,1.15-.61,1.67-1.77,1.39a2,2,0,0,1-1.72-2.2c0-1.81.09-3.62.14-5.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "345.699px 316.512px"
    },
    id: "el5rjlt9r7ipx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.27,315.8h0l0,5.26-1.07-.25v-7.24l1.43.31c.4,1.54.81,3.08,1.22,4.62h0l-.06-4.38,1,.21.15,7.35-1.23-.28C350.25,319.53,349.76,317.66,349.27,315.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.07px 317.625px"
    },
    id: "elrbrhnb01j3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.91,317.85l1.61.29c0,.36,0,.71,0,1.07l-1.62-.31c0,.73.05,1.45.07,2.17l2.06.4c0,.35,0,.71,0,1.06q-1.64-.3-3.27-.66l-.18-7.36c1,.2,2.09.4,3.14.56,0,.36,0,.71.05,1.07l-2-.35C353.87,316.47,353.89,317.16,353.91,317.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "354.305px 318.52px"
    },
    id: "eltpklvb21j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.11,365.45c-19.7,2.81-39.42-14.92-59.28-9.27.42-9.67,1.26-19.34,2.44-29,18.14-5.54,36.42,9.75,54.91,3.67C377.34,342.3,378,353.84,378.11,365.45Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "348.47px 345.851px"
    },
    id: "eln72ssrhr1wj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68,365.89c-20.09,3.24-40.18-15.31-60.42-9.09.42-10,1.29-19.95,2.55-29.92,18.45-6,37,9.91,55.82,3.24C377.86,342,378.58,353.88,378.68,365.89Zm-59.27-10.3c19.46-5.12,38.81,11.82,58.14,9.41-.11-11.22-.75-22.37-1.83-33.45-18.18,5.5-36.17-9.13-54-4.08Q320,341.53,319.41,355.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.47px 345.886px"
    },
    id: "elha29ap4firc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.5,331.61c15.81-.47,32.15,10.66,48.29,5.87.78,9.28,1.24,18.6,1.32,28-17,2.49-33.83-10.45-50.95-10.35Q327.55,343.35,328.5,331.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "352.635px 348.697px"
    },
    id: "el8hbkh1yh5r7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68,365.89c-17.38,2.87-34.58-10.72-52.09-10.34q.41-12.18,1.43-24.38c16.11-.74,32.8,10.92,49.25,5.61C378.11,346.43,378.6,356.13,378.68,365.89Zm-50.95-11.24c16.73.17,33.22,12.49,49.82,10.35q-.14-13.47-1.23-26.82c-15.83,4.29-31.83-6.34-47.33-6.13Q328.1,343.36,327.73,354.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.635px 348.712px"
    },
    id: "el4zzqdnjcs5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.71,355.1c-.37,0-.74,0-1.11,0q.5-14.53,1.88-29.1l1,0Q328.2,340.55,327.71,355.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.04px 340.55px"
    },
    id: "elzr1129dfabi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.59,356.46l-1.11-.25q.25-14.74,1-29.55l1,.18Q337.84,341.68,337.59,356.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "337.48px 341.56px"
    },
    id: "elh6l1bzu6jn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.45,359.36l-1.1-.37q.06-15.14.18-30.32l1,.26Q347.51,344.17,347.45,359.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.94px 344.015px"
    },
    id: "elvf90nhla1cs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,362.68l-1.1-.36q0-15.69-.5-31.4l1,.22Q357.22,346.92,357.28,362.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "356.48px 346.8px"
    },
    id: "elqqle9tnbua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.07,365.22,366,365c0-10.94-.42-21.85-1.07-32.73l1,0C366.63,343.27,367,354.23,367.07,365.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "366px 348.745px"
    },
    id: "el4l152zgo7w3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.84,338c-18.93,5.44-37.66-10.34-56.26-4.8l.09-.9c18.55-5.54,37.21,10.17,56.08,4.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.71px 335.128px"
    },
    id: "el2c4e2oke7ap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.36,345.08c-19.27,4.8-38.36-11.48-57.37-5.93,0-.3.05-.6.08-.9,19-5.55,38,10.66,57.22,5.76C377.31,344.37,377.34,344.72,377.36,345.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.675px 341.527px"
    },
    id: "el0y7snownpfv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.75,352.16c-19.51,4.13-38.89-12.65-58.26-7.08,0-.29.05-.59.07-.89,19.31-5.57,38.66,11.13,58.14,6.9C377.72,351.45,377.73,351.8,377.75,352.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.62px 347.931px"
    },
    id: "elf8ut691rbpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,359.26c-19.65,3.44-39.25-13.85-58.9-8.24,0-.3,0-.6,0-.9,19.61-5.6,39.18,11.61,58.82,8.07C378,358.55,378,358.91,378,359.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.55px 354.353px"
    },
    id: "el8r8hnlklit7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37,298.64c-.05-.3-.28-.36-.51-.16-18.93,14.81-38.27-6.4-57.89,4.78a1.22,1.22,0,0,0-.58.72,325.26,325.26,0,0,0-6.06,52.48c0,.25.24.31.54.15,23.54-12.38,46.79,14.61,70.26,6.64a.93.93,0,0,0,.57-.78A346.54,346.54,0,0,0,109.37,298.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "80.015px 331.557px"
    },
    id: "elqh31xqwple",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.13,363.25c-23.47,8-46.72-19-70.26-6.64-.3.16-.54.1-.54-.15A325.26,325.26,0,0,1,50.39,304a1.22,1.22,0,0,1,.58-.72c19.62-11.18,39,10,57.89-4.78.23-.2.46-.14.51.16a346.54,346.54,0,0,1,6.33,63.83A.93.93,0,0,1,115.13,363.25Zm-69.69-7.83c23.16-11.53,46.05,14.32,69.12,6.93a353,353,0,0,0-5.92-62.43c-18.83,13.88-38-6.53-57.34,4A334.68,334.68,0,0,0,45.44,355.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.015px 331.572px"
    },
    id: "elm1miadz06qm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,316.76c-21.09,13.12-42.23-9.7-63.49,1.7q1.11-7.38,2.53-14.75C70.55,292.52,90,313.78,109,299Q110.61,307.86,111.85,316.76Z",
    style: {
      fill: "current",
      transformOrigin: "80.105px 309.983px"
    },
    id: "el8cht9hk6p06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4,317c-21.44,13.9-43-9.94-64.64,2.21q1.18-7.83,2.71-15.65c20-11.9,39.64,10.24,58.8-5.43Q111.07,307.49,112.4,317ZM49,317.75c20.85-10.68,41.61,11.16,62.35-1.2q-1.15-8.35-2.66-16.63c-18.83,13.88-38-6.53-57.34,4Q50,310.83,49,317.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.08px 309.818px"
    },
    id: "elzcnkjqhqgz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4,306.61A1.55,1.55,0,0,1,68.25,305a1.69,1.69,0,0,1,1.58,2c-.07,1.21-.15,2.43-.22,3.65a1.46,1.46,0,0,1-1.87,1.51,1.66,1.66,0,0,1-1.64-1.94Zm.85,3.8c0,.5.19.72.56.76s.61-.11.64-.61c.08-1.26.17-2.52.26-3.78,0-.5-.18-.72-.54-.76s-.6.13-.63.62C67.44,307.9,67.34,309.16,67.25,310.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "67.9676px 308.595px"
    },
    id: "elsblx75hd689",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.75,310.47l0,.94a1.34,1.34,0,0,1-1.81,1.43,1.84,1.84,0,0,1-1.65-2.08l.21-3.66c.06-1.12.67-1.68,1.77-1.48a1.85,1.85,0,0,1,1.61,2.1l0,.69-1.08-.21c0-.26,0-.51,0-.76,0-.51-.2-.74-.56-.81s-.59.09-.62.59L71.42,311a.66.66,0,0,0,.57.8c.37.07.61-.06.63-.57,0-.34,0-.67,0-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "72.086px 309.255px"
    },
    id: "elqaoiwbnhg6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26,306.09c1.16.23,2.33.48,3.49.74,0,.34,0,.68,0,1l-1.19-.27q-.06,3.07-.11,6.14l-1.18-.27q.08-3,.16-6.11l-1.19-.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.995px 309.895px"
    },
    id: "eluesc0k6obih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.14,308.65c0-1.15.62-1.68,1.74-1.43a2.11,2.11,0,0,1,1.75,2.21c0,1.26,0,2.53,0,3.79s-.62,1.69-1.79,1.41a2.15,2.15,0,0,1-1.78-2.24C78.11,311.14,78.13,309.9,78.14,308.65Zm1.13,4.09a.76.76,0,0,0,.61.85c.38.09.62,0,.61-.57,0-1.3,0-2.61,0-3.92,0-.52-.24-.77-.6-.85s-.59.07-.6.58C79.28,310.14,79.28,311.44,79.27,312.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "79.8453px 310.936px"
    },
    id: "eluxx6ee6lwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.84,310.22a2.17,2.17,0,0,0,0,.26c0,.77-.19,1.2-.71,1.34v0a1.92,1.92,0,0,1,.93,1.75c0,.2,0,.4,0,.6,0,1.15-.57,1.64-1.76,1.38l-1.88-.42c0-2.44-.07-4.88-.1-7.31l1.73.35A1.92,1.92,0,0,1,85.84,310.22Zm-2.33-1.1c0,.65,0,1.3,0,1.95l.45.09c.44.09.7-.05.68-.64,0-.13,0-.27,0-.41,0-.52-.2-.79-.61-.87Zm.07,3c0,.76,0,1.51,0,2.26l.69.15c.39.08.61,0,.59-.6,0-.21,0-.43,0-.64,0-.69-.24-.94-.78-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "84.1914px 311.719px"
    },
    id: "el43mlet2whwz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.88,312c.54.09,1.07.17,1.61.24l.06,1.08-1.63-.25c0,.73.07,1.46.1,2.19.68.12,1.37.23,2.06.32l.06,1.08c-1.1-.16-2.19-.35-3.28-.56-.08-2.48-.18-5-.28-7.43,1,.17,2.1.33,3.15.45l.06,1.08c-.67-.08-1.34-.18-2-.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.36px 312.665px"
    },
    id: "eli6ylfb4u3ho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.39,317a2.49,2.49,0,0,1-.17-.95c0-.4,0-.8-.08-1.2,0-.71-.3-1-.84-1l-.41,0c.07,1,.13,2.06.19,3.1l-1.2-.15q-.21-3.78-.43-7.56.87.09,1.74.15a1.75,1.75,0,0,1,1.86,1.84c0,.2,0,.4,0,.6.06.79-.15,1.29-.66,1.51v0a1.78,1.78,0,0,1,.91,1.67c0,.39,0,.78.08,1.18a2.5,2.5,0,0,0,.2.94Zm-1.71-6.64.15,2.34.46,0c.44,0,.69-.15.65-.76l-.06-.75c0-.55-.23-.8-.64-.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.515px 313.185px"
    },
    id: "elp3tz7012ryi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.65,359.16c-19.71,2.81-39.43-14.92-59.28-9.27q.63-14.52,2.44-29c18.13-5.53,36.42,9.75,54.9,3.68C108.87,336,109.54,347.55,109.65,359.16Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "80.01px 339.563px"
    },
    id: "el33nnubjbulg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,359.6C90.12,362.83,70,344.28,49.8,350.5c.42-10,1.29-19.95,2.54-29.92,18.46-6,37,9.92,55.82,3.24C109.4,335.67,110.11,347.59,110.21,359.6ZM50.94,349.29c19.47-5.11,38.82,11.83,58.15,9.42-.12-11.22-.75-22.37-1.83-33.46-18.19,5.51-36.17-9.12-54-4.07C52.15,330.55,51.35,339.92,50.94,349.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.005px 339.591px"
    },
    id: "el6amqzb3abjw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,325.31c15.8-.46,32.15,10.67,48.29,5.88q1.17,13.92,1.32,28c-17,2.49-33.84-10.45-51-10.36Q59.08,337.07,60,325.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "84.11px 342.402px"
    },
    id: "elqxr61hx5pen",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,359.6c-17.37,2.87-34.58-10.73-52.09-10.35q.41-12.17,1.44-24.37c16.11-.74,32.79,10.92,49.24,5.6Q110.08,345,110.21,359.6ZM59.26,348.36c16.73.17,33.22,12.48,49.83,10.35-.09-9-.52-17.93-1.24-26.83C92,336.17,76,325.55,60.52,325.76Q59.65,337.07,59.26,348.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "84.165px 342.422px"
    },
    id: "ellzm4llazguc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25,348.81H58.14q.49-14.54,1.87-29.11l1,0Q59.74,334.26,59.25,348.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "59.575px 334.255px"
    },
    id: "el54e6jfpaseb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.12,350.17,68,349.91q.27-14.75,1-29.54c.34.05.68.11,1,.18Q69.37,335.39,69.12,350.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "69px 335.27px"
    },
    id: "elsnb46lxah7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,353.07l-1.11-.37q.06-15.13.19-30.33l1,.27Q79,337.88,79,353.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "78.485px 337.72px"
    },
    id: "elhegef9agxy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.82,356.39,87.71,356q0-15.69-.49-31.4l1,.22Q88.76,340.62,88.82,356.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.02px 340.495px"
    },
    id: "elhhk5ektjfcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.61,358.93l-1.1-.2q-.08-16.41-1.08-32.74l1,.05C98.16,337,98.56,347.94,98.61,358.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "97.52px 342.46px"
    },
    id: "el0w2nvuo3rok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37,331.72c-18.92,5.45-37.65-10.34-56.26-4.8,0-.3.07-.6.1-.9,18.54-5.53,37.21,10.18,56.07,4.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.24px 328.852px"
    },
    id: "elp234d1e410h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.89,338.79c-19.26,4.8-38.35-11.49-57.37-5.93,0-.3.06-.6.08-.9,19-5.55,38,10.66,57.22,5.76C108.85,338.07,108.87,338.43,108.89,338.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.205px 335.237px"
    },
    id: "elvo8e6ejbpis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,345.87C89.77,350,70.39,333.22,51,338.79l.06-.89c19.32-5.58,38.66,11.13,58.14,6.9C109.25,345.16,109.27,345.51,109.28,345.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.14px 341.639px"
    },
    id: "elrpvnqurjsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.54,353c-19.66,3.43-39.26-13.85-58.91-8.24,0-.3,0-.6,0-.9,19.62-5.61,39.19,11.61,58.83,8.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.085px 348.091px"
    },
    id: "eli2whkkd1ye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,114.54A379.29,379.29,0,0,1,78.61,75.73a.56.56,0,0,0-.71-.07,269.81,269.81,0,0,0-38.5,34,.53.53,0,0,0,.06.7,410.86,410.86,0,0,1,40.73,52.22.47.47,0,0,0,.72.07,340.57,340.57,0,0,0,45-47.39A.49.49,0,0,0,125.84,114.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "82.6657px 119.175px"
    },
    id: "elqfgfyxdmlb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,162.58a410.86,410.86,0,0,0-40.73-52.22.53.53,0,0,1-.06-.7,269.81,269.81,0,0,1,38.5-34,.56.56,0,0,1,.71.07,379.29,379.29,0,0,0,47.23,38.81.49.49,0,0,1,0,.72,340.57,340.57,0,0,1-45,47.39A.47.47,0,0,1,80.19,162.58ZM40.41,110.1a427.57,427.57,0,0,1,40.34,51.3,348.68,348.68,0,0,0,44-46.26A394.84,394.84,0,0,1,78.23,76.59,279.86,279.86,0,0,0,40.41,110.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.6465px 119.157px"
    },
    id: "eljfno1ptla3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76,129.14Q89.37,107.68,66.68,84.92,72.32,80.33,78.25,76a387.32,387.32,0,0,0,47.24,39Q119.81,122.24,113.76,129.14Z",
    style: {
      fill: "current",
      transformOrigin: "96.085px 102.57px"
    },
    id: "el3fp68wh0zlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78,129.91Q89,108,66,84.84q6-4.87,12.28-9.44a379.31,379.31,0,0,0,48,39.42Q120.21,122.56,113.78,129.91ZM67.38,85q22.34,22.34,46.36,43.39,5.66-6.48,11-13.25A394.84,394.84,0,0,1,78.23,76.59Q72.68,80.68,67.38,85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.14px 102.655px"
    },
    id: "elkbaaxysziz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.91,88.32l1.37,1.27a1.37,1.37,0,0,1,0,2.33l-2.65,2.36a1.72,1.72,0,0,1-2.6-.09l-1.39-1.33C81.39,91.34,83.14,89.82,84.91,88.32ZM85,89.77,81.27,93l.49.47a.62.62,0,0,0,1,0l2.73-2.41c.37-.33.34-.6.06-.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "83.2846px 91.5752px"
    },
    id: "eltmd001klmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,94.06,88,95.17l-.75.68-1.21-1.12-1.53,1.39,1.53,1.42-.75.69L82.9,96q2.61-2.35,5.24-4.68l2.4,2.16-.75.68-1.52-1.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.72px 94.775px"
    },
    id: "el5819jcm9awx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.38,99.3l-.69.65a1.74,1.74,0,0,1-2.64,0,1.49,1.49,0,0,1,0-2.44L89.76,95a1.79,1.79,0,0,1,2.63,0,1.45,1.45,0,0,1,0,2.41l-.5.48-.84-.76.56-.52c.37-.35.33-.64,0-.9a.65.65,0,0,0-1,.07c-1,.87-1.89,1.75-2.82,2.62-.38.35-.33.64,0,.9a.63.63,0,0,0,1,0l.74-.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.7244px 97.4904px"
    },
    id: "elh0bhk0yg0fe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.89,99.57l1.23,1.09c-.25.24-.5.48-.74.73l-1.23-1.11-1.53,1.47,1.55,1.41-.75.72c-.82-.74-1.63-1.49-2.44-2.24l5.22-5c.81.71,1.62,1.42,2.44,2.12l-.75.73-1.54-1.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.81px 100.26px"
    },
    id: "elk2yy5gt49q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.38,104.61h0q2.16-1.58,4.32-3.18l1.26,1.07-5.23,5.31-.86-.77c1.25-1.26,2.51-2.52,3.75-3.78h0c-1.45,1.08-2.91,2.16-4.36,3.22l-.85-.77c1-1.42,2-2.83,3-4.24h0l-3.69,3.64-.79-.72,5.23-5.11,1.25,1.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.445px 103.545px"
    },
    id: "elci41a0ktn3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.16,106.61l-.18.19a1.56,1.56,0,0,1-1.64.6h0a1.43,1.43,0,0,1-.44,1.76l-.42.45a1.7,1.7,0,0,1-2.63.06l-1.43-1.27q2.63-2.67,5.24-5.35c.45.39.91.77,1.37,1.15A1.42,1.42,0,0,1,103.16,106.61Zm-1.36-2L100.42,106l.35.3c.34.29.69.33,1.11-.11l.29-.3c.37-.39.39-.68.07-1Zm-2.13,2.2-1.61,1.65.52.46c.3.27.6.29,1-.12l.46-.47c.48-.51.46-.81,0-1.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.094px 106.657px"
    },
    id: "el97302lij2yl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.71,109l1.26,1.06-.75.81L103,109.78l-1.54,1.64L103,112.8l-.76.8-2.49-2.2q2.64-2.76,5.26-5.53l2.51,2.06-.75.81-1.59-1.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.635px 109.735px"
    },
    id: "elrgwoa9soqs8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,115.78a2.56,2.56,0,0,1,.57-.78l.84-.91c.49-.54.49-.9.07-1.25l-.32-.27-2.16,2.33-.92-.8c1.77-1.89,3.54-3.8,5.29-5.71l1.39,1.13a1.47,1.47,0,0,1,.17,2.46l-.42.47a1.65,1.65,0,0,1-1.67.68h0c.29.58,0,1.15-.51,1.76l-.82.9a2.21,2.21,0,0,0-.55.8Zm3.54-5.81-1.62,1.77.36.3c.34.29.69.32,1.11-.15l.53-.57c.37-.42.39-.72.07-1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.518px 112.49px"
    },
    id: "elgdjx5qftyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.48,154.62A497.78,497.78,0,0,0,46,110.86q10-10.23,20.85-19.61,19.41,19.52,39.62,38.58Q94.54,142.79,81.48,154.62Z",
    style: {
      fill: "rgb(191, 191, 191)",
      transformOrigin: "76.235px 122.935px"
    },
    id: "elsty0ae1ogug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.39,155.42A490.58,490.58,0,0,0,45.3,110.78q10.23-10.55,21.48-20.19,19.77,19.86,40.39,39.2Q94.92,143.2,81.39,155.42ZM46.62,110.93a512.1,512.1,0,0,1,35,42.9q12.58-11.47,24.11-24-19.8-18.8-38.85-38Q56.3,101,46.62,110.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.235px 123.005px"
    },
    id: "elh072te48d6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,100.48q16.75,17.13,33.7,34.31Q92,145.07,81.48,154.62q-14.31-19.8-30.27-37.9Q59.43,108.41,68.1,100.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.505px 127.55px"
    },
    id: "eljiscxmqp6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.39,155.42a490.19,490.19,0,0,0-30.84-38.78Q59.07,108,68.07,99.81q17.12,17.46,34.47,35Q92.39,145.49,81.39,155.42ZM51.87,116.79q15.63,17.73,29.71,37,10.08-9.18,19.47-19-16.53-16.87-32.92-33.65Q59.81,108.8,51.87,116.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.545px 127.615px"
    },
    id: "elf1qs02nx36d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,117.11c-.24-.26-.47-.52-.7-.79Q61,106,71.9,96.35c.25.24.49.48.73.73Q61.77,106.8,51.56,117.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "61.745px 106.73px"
    },
    id: "elhrp76x7m0r7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,124.17l-.68-.8q10.55-10.43,21.44-20.57l.73.72Q68.24,113.72,57.65,124.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.055px 113.485px"
    },
    id: "elu6zsfyik5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,131.36l-.67-.81,22-21.32.74.72Q74.67,120.69,63.63,131.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "74.33px 120.295px"
    },
    id: "el67bmjhmh3gl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,138.68c-.22-.28-.44-.55-.65-.83q11.52-10.93,22.72-22.22l.74.71Q81.07,127.71,69.48,138.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "80.56px 127.155px"
    },
    id: "elz0gk92pe26q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.21,146.12l-.64-.84Q86.72,134,98.18,122l.75.72Q87.44,134.78,75.21,146.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "86.75px 134.06px"
    },
    id: "elaq4tcb4jq4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42,135.18q-19.67-20.06-39.11-40L63,94.6q19.45,19.88,39.2,39.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.255px 114.89px"
    },
    id: "elditjd5lezo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.41,140.34q-19-21-38.44-41.2l.65-.6q19.42,20.2,38.55,41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.57px 119.44px"
    },
    id: "el7xcubvg2cj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,145.4Q73,123.65,53.71,103.16l.64-.62Q73.67,123,92.08,144.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "72.895px 123.97px"
    },
    id: "el9zoqe0kiwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,150.37Q68.64,127.9,49.53,107.24l.63-.62q19.14,20.64,36.73,43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.21px 128.495px"
    },
    id: "el8zqauuaj6xe",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.76,246.34s-2.25-14.24,0-22.55-46-16.13-46-16.13L222.1,228.14s2,8.76,0,26.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.44,246.75s35.87-4.84,62.77-2.1L287.37,263s32.7,70,38.51,82.86,30.5,53.94,30.5,53.94-12.83-2.07-17.32,19.74c0,0-50.11-66-54.33-73.68S255,300,255,300h-7.19s-26.32,46.81-28.43,50.66S194,405,186.1,419.54c0,0-9.81-28.58-23.06-16,0,0,10.92-28.79,12-29.2s5.7-22.55,8.65-26.25S218.27,263,218.27,263Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.47,153.77s6.3-1.66,20.81,3.63c0,0,20.77-3.58,29,0a49,49,0,0,1,18.77-5s27.43-14.29,35.34-17.09,20.05-10.15,23.74-12.81,14.24-5.82,14.24-5.82a14.77,14.77,0,0,1,5.27-3.63s12.14,11.59,11.08,18.43l-4.22,1.29S290,185,287.37,186.69c-1.32.86,1.55,5.93.79,19.3-.83,14.7,6.53,26.67,4.19,34.53,0,0-7.23-11.62-29.18-10.53-18,.89-47.54,25.5-47.54,25.5a84.36,84.36,0,0,1,.18-22.33c2.2-15.57.35-38.34.35-41.59,0-5.27-70.68-48.89-70.68-48.89l-3.69-.92-9.5-7.61s6.33-20.45,16.88-18.27l9,6.34,11.34,6.09S200.34,148.67,212.47,153.77Z",
    style: {
      fill: "current",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookVisit);
export default __webpack_public_path__ + "static/media/bookVisit.9787ceac.svg";
export { ForwardRef as ReactComponent };